import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Renderer2,
  Input,
  NgModule,
  OnDestroy,
  OnInit,
  ViewChild,
  NO_ERRORS_SCHEMA,
  ViewEncapsulation,
  isDevMode
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, combineLatest, firstValueFrom, from, Observable, of, Subject, Subscription, throwError, timer } from 'rxjs';
import { catchError, connect, delay, filter, finalize, map, takeUntil, tap } from 'rxjs/operators';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { ionSendSharp, ionMic } from '@ng-icons/ionicons';
import { environment } from '../../environments/environment';
import { debugLog } from '../services/debug-log.service';
import { BrowserModule, DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DeepgramWebSocketService } from '../services/deepgramWebSocket.service';
import { v4 as uuidv4 } from 'uuid';
// import { DeepgramSDKService } from '../services/deepgramSDK.service';

import { DeviceDetectorService } from 'ngx-device-detector';

import { SseClient } from 'ngx-sse-client';
import { Filter } from 'bad-words'

import { Marked, Renderer } from '@ts-stack/markdown';

import {
  ChatMessage,
  MessageSenderTypeEnum,
  MessageTypeEnum,
} from './model_ai_chat';

import { AudioWaveCircle } from '../common/audioWaveCircle';

import { chartFromTextParser, EChartsDomObject } from '../common/chartFromTextParser';

import { markdown } from '../common/markdown';

import { ActivatedRoute, Router, RouterModule } from '@angular/router';

//import { createClient, LiveTranscriptionEvents, LiveTTSEvents } from "@deepgram/sdk";

import { EnvironmentTypeEnum } from '../common/env_enum';
// import { KubernetesPatch } from 'aws-cdk-lib/aws-eks';
// import { UserInputService } from '../services/userInput.service';
// import { PollyService } from '../services/polly.service';
// import { AudioStreamService } from '../services/audioStream.service';
import { TextToSpeechService } from '../services/textToSpeech.service';

import { DeepgramOneService } from '../services/deepgramOne.service';


// import * as echarts from 'echarts';
import { NgxEchartsDirective, provideEcharts } from 'ngx-echarts';
import type { EChartsOption, ECharts } from 'echarts';
import { JwtService } from '../services/jwt.service';
import { ChatbotAgentComponent } from '../chatbot_agent/chatbot_agent.component';
import { BootStateService } from '../boot/boot-state.service';
import { BootState, loadCachedSession, saveCachedSession } from '../boot/boot-state';
import { ClientLogService } from '../services/client-log.service';
import { MicrophoneService } from '../services/microphone.service';
import { SessionAuthService } from '../services/session-auth.service';
import { getApiAuthHeaders } from '../services/session-auth.store';
import { getLoadTimingSummary, markLoad } from '../boot/load-timing';

type ParsedTableRow = Record<string, string>;


// Deepgram API Key
// const deepgramAPIKey = "<redacted>";
// const deepgramClient = createClient(deepgramAPIKey);
//const deepgramAPIKey = "<redacted>";
// const deepgramClient = createClient(deepgramAPIKey);
// console.log("Deepgram Instance: ", deepgramClient);
// const dgConnectionSpeak = deepgramClient.speak.live({ model: "aura-asteria-en"});//,encoding: "linear16",container: "wav" });

declare var webkitSpeechRecognition;


let audioCaptureSub;


@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [FormsModule, CommonModule, RouterModule, NgxEchartsDirective, ChatbotAgentComponent],
  viewProviders: [provideIcons({ ionSendSharp, ionMic })],
  templateUrl: './chatbot.component.html',
  styleUrl: './chatbot.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    provideEcharts(),
  ]
})
export class ChatbotComponent implements OnInit, AfterViewInit, OnDestroy {
  currentSessionId: string;
  echartOptions: EChartsDomObject[] = [{key: 0, value: {}, optionality: {height: '0px'}}];

  tableOptions: [{key: number, valueArray: any, optionality: any}] = [{key: 0, valueArray: [], optionality: {height: '0px'}}];
  tOptionsIdx;

  // ..all testing here so vet when ready to push out of dev work
  streamResponseTextChunksArray:any[] = ["asdf", "234", "2345", "12334"];
  streamResponseTextChunksAudioArray:any[] = [];
  text: string = '';
  isLoading: boolean = false;
  error: string | null = null;
  audioSource: SafeUrl | null = null;
  private audioBuffer: AudioBuffer | null = null;
  private audioBuffers: ArrayBuffer[] = [];
  private audioQueue: AudioBuffer[] = [];
  isPlaying = false;
  hasAudioToPlay = false;
  private textBuffer: string = '';
  public accumulatedText: string = '';


  public errorCode4Chars = '';


  privInfo;


  microphoneButton:any;// = document.getElementsByClassName("start-recording-button")[0];
  recordingControlButtonsContainer:any;// = document.getElementsByClassName("recording-contorl-buttons-container")[0];
  stopRecordingButton:any;// = document.getElementsByClassName("stop-recording-button")[0];
  cancelRecordingButton:any;// = document.getElementsByClassName("cancel-recording-button")[0];
  elapsedTimeTag:any;// = document.getElementsByClassName("elapsed-time")[0];
  closeBrowserNotSupportedBoxButton:any;// = document.getElementsByClassName("close-browser-not-supported-box")[0];
  overlay:any;// = document.getElementsByClassName("overlay")[0];
  audioElement: HTMLAudioElement | null = null;// = document.getElementsByClassName("audio-element")[0];
  audioElementSource: HTMLAudioElement;// = document.getElementsByClassName("audio-element")[0].getElementsByTagName("source")[0];
  textIndicatorOfAudiPlaying:any;// = document.getElementsByClassName("text-indication-of-audio-playing")[0];

  /** Stores the actual start time when an audio recording begins to take place to ensure elapsed time start time is accurate*/
  audioRecordStartTime;

  /** Stores the maximum recording time in hours to stop recording once maximum recording hour has been reached */
  maximumRecordingTimeInHours = 1;

  /** Stores the reference of the setInterval that controls the timer in audio recording*/
  elapsedTimeTimer;
  //.....



  @ViewChild('circleAudioWavesOverlay') circleAudioWavesOverlayEl: ElementRef;

  final__speak_now_text = "begin speaking...";
  final__ui_user_input_placehoder_text = "Ask Ai Assistant";
  /** Placeholder for the conversation screen input (after first message). */
  readonly conversationInputPlaceholder = "Ask Sara Ai Assistant";
  final__audio_intake_timeout_ms = 30000;
  final__audio_wave_animation_timeout_ms = 30000;

  tmp__ui_user_input_placehoder_text = this.final__ui_user_input_placehoder_text;

  listOfSpechOutputPunctuations = [",", ".", "?"];

  cif: string = ''; // Store query param value
  currentUserName: string = '';
  token: string = '';
  isAdmin: boolean = false;
  isAppAdmin: boolean = false; // To Override In Other Environments
  isToRecordToFile: boolean = false;


  chatMessageId = 0;

  isSocketOpen = true;

  socket: any;
  microphone: any;
  userMedia: any;
  microphoneIdleTime: number = 0;

  //private audio: HTMLAudioElement | null = null;

  private messagesSubject = new BehaviorSubject<ChatMessage[]>([]);
  messages$: Observable<ChatMessage[]> = this.messagesSubject.asObservable();

  messages: ChatMessage[] = [];

  userInput = '';

  userInput$ = new BehaviorSubject<string>('');
  set userInputNgModel(val: string) {
    this.userInput$.next(val);
  }
  get userInputNgModel(): string {
    return this.userInput$.value;
  }

  isTyping: boolean = false;
  isChatbotAvailable$ = new BehaviorSubject(false);
  isChatbotAccessible$ = new BehaviorSubject(true);
  isTokenValidating$ = new BehaviorSubject(false);
  showLandingScreen$ = new BehaviorSubject(true);
  showAuthError$ = new BehaviorSubject(false);
  isSessionReady$ = new BehaviorSubject(false);
  entryVeilHidden$ = new BehaviorSubject(false);
  landingAnimationsReady$ = new BehaviorSubject(false);
  speechResult: string = '';
  isSpeechListening$ = new BehaviorSubject(false);
  isServerResponding$ = new BehaviorSubject(false);
  isDeleteUserInputOptionAvailable$ = new BehaviorSubject(false);
  isAudioPlaybackStarted$ = new BehaviorSubject(false);
  isAudioTTOSPlaying$ = new BehaviorSubject(false);
  isWaitingForMicAudioOrSocket$ = new BehaviorSubject(false);
  vSearch;
  isConversationalAgent$ = new BehaviorSubject(false);

  // Combine states into one observable for readability and efficiency
  isButtonDisabled$: Observable<boolean> = combineLatest([
    this.isSpeechListening$,
    this.isServerResponding$,
    this.isTokenValidating$,
  ]).pipe(map(([isListening, isResponding, isValidating]) => isListening || isResponding || isValidating));


  isSendReady$ = new BehaviorSubject(false);
  isSendEligible$: Observable<boolean> = combineLatest([
    this.isSpeechListening$, // Observable<boolean>
    this.userInput$ // Observable<string>
  ]).pipe(
    map(([isListening, userInput]) =>

      // updating so that the circle colored send appears really as soon as there is length in the input for the transcribe
      // it should ensure works like 'ok' and 'yes' give the icon change
      userInput?.length > 1
      //!isListening && userInput !== ''
    )
  );

  // Initialize Audio Wave circle visualization
  svgAudioWaveCircle; //this will be the elementRef to the SVG
  waveCircleClassObj; //instantiation of the class


  // SSE streaming to server from main server
  messages_test: string[] = [];
  eventSource: EventSource;
  isStopStream$ = new BehaviorSubject(false); //new Subject<void>();
  //private mediaRecorder: MediaRecorder;

  // Deepgram
  private audioContext: AudioContext | null = null;
  private microphoneStream: MediaStream | null = null;
  private audioWorkletNode: AudioWorkletNode | null = null;

  private connection;
  //private connectionObj = deepgramClient.listen;
  totalUserInput: string[] = []; //also used infront end toshow items like bin/trash if not empty



  private mediaStream: MediaStream | null = null;
  private mediaStreamSource: MediaStreamAudioSourceNode | null = null;


  //autosend variable so we can use the clearTimeout(var) option with stop functions
  private autoSendFromTranscribeTimeout: any;


  // testing stream bytes
  streamBytes$ = new BehaviorSubject<number>(0);

  isRecording = false;
  transcript: string | null = null;

  // Filter for Offensive words
  offensiveFilter = new Filter();

  commonQuestions: string[] = [
    'What is my current portfolio size?',
    'What is the best performing project in my portfolio?',
    'What is my available GFH Cash Account Balance?',
  ];
  contextualSuggestions: string[] = [];

  private readonly contextualSuggestionRules: Array<{ keywords: string[]; suggestions: string[] }> = [
    {
      keywords: ['credit card', 'khaleeji', 'cashback', 'card balance'],
      suggestions: [
        'What are the benefits of the GFH Credit Card?',
        'Who is eligible to apply for the GFH credit card?',
        'How can I apply for the GFH Credit Card?',
      ],
    },
    {
      keywords: ['wakala', 'وكالة'],
      suggestions: [
        'What are the latest Wakala rates?',
        'What is the maturity date of my Wakala investment?',
        'Show my active Wakala positions.',
      ],
    },
    {
      keywords: ['nav', 'opportunit', 'fund'],
      suggestions: [
        'What are today\'s NAV opportunities?',
        'Show all NAV opportunities.',
        'How are NAV opportunities selected?',
      ],
    },
    {
      keywords: ['portfolio', 'investment', 'holdings', 'sector', 'allocation'],
      suggestions: [
        'What is my total portfolio size?',
        'Which investment is performing best?',
        'Show portfolio performance by product type.',
      ],
    },
    {
      keywords: ['cash', 'balance', 'account', 'transaction'],
      suggestions: [
        'What is my available cash account balance?',
        'What are my recent transactions?',
        'Show a breakdown of my account balances.',
      ],
    },
    {
      keywords: ['matur', 'duration', 'tenor'],
      suggestions: [
        'Which investments are maturing soon?',
        'What is the average duration of my portfolio?',
        'Show maturity dates for my Wakala investments.',
      ],
    },
    {
      keywords: ['real estate', 'hospital', 'housing', 'project', 'clinic'],
      suggestions: [
        'What is the NAV of my real estate projects?',
        'Which project has the highest return?',
        'Show me details for all my projects.',
      ],
    },
    {
      keywords: ['return', 'performance', 'roi', 'profit', 'gain'],
      suggestions: [
        'What is my overall portfolio return?',
        'Which asset class is performing best?',
        'Show me my returns over the last year.',
      ],
    },
  ];

  // words to be used the the client to show as a bot response to show immediate activity

  greetingResponses = [
    'Hello! 👋 How can I assist you today?',
    'Hi there! 😊 What can I help you with?',
    'Hey! 👋 Let me know how I can assist.',
    'Hello! 🌟 How can I assist you with your banking needs today?',
    'Hi! 🤗 What brings you here today?',
  ];

  thankYouResponses = [
    "You're welcome! 😊",
    'Happy to help! 👍',
    'No problem at all! 🤝',
    'Anytime! 🙌',
    'Glad I could assist! 💼',
  ];

  initialBotResponseWords = [
    'Sure, let me check... 🔍',
    'Got it, one moment... ⏳',
    'Alright, looking into it... 📂',
    'Okay, let me find that for you... 🗂️',
    'Just a moment, I will fetch the details... 💾',
    'Let me process this for you... 🧮',
    'Checking that right away... ✅',
    'Let me access the details... 🏦',
    'Looking into your request... 🔧',
    'One moment while I retrieve the details... 📊',
    'Processing your query now... ⏱️',
    'Let me fetch those details for you... 📜',
    'Let me review this for you... 🔎',
    'Hold on while I retrieve the information... 🔗',
  ]

  defaultBotQuickResponse = "Analyzing...";

  @ViewChild('messageArea', { static: false }) chatContent!: ElementRef;

  @ViewChild('captions', { static: false }) deepgramCaptions!: ElementRef;

  @ViewChild('mainTextInput', { static: false }) mainTextAreaInput!: ElementRef;

  private apiUrl = environment.apiUrl;
  private botConversationMode = environment.conversationMode;
  currentEnvironment = environment.environmentName;

  isMobileSafariEnv = false;
  isAndroidPlatform = false;
  isShowAdminUIControls = false;
  recordedFileChunks = [];

  strTest = "";

  private streamOfTextToPollyAudio:Observable<string> = new Observable<string>;





  private readonly internalSub = new Subscription();
  private visualViewportCleanup?: () => void;
  private visualViewportUpdate?: () => void;
  private authValidationStarted = false;
  private entryAnimationFrameId: number | null = null;

  // Inject HttpClient in the constructor
  constructor(private http: HttpClient
    , private route: ActivatedRoute
    , private deepgramWebSocketService: DeepgramWebSocketService
    // , private pollyService: PollyService //nnot using currently but keep for client side
    , public deviceService: DeviceDetectorService
    , private textToSpeechService: TextToSpeechService
    , private sseClient: SseClient
    , private renderer: Renderer2
    , private el: ElementRef
    , private jwtService: JwtService
    , private router: Router
    , private bootStateService: BootStateService
    , private clientLogService: ClientLogService
    , private microphoneService: MicrophoneService
    , private sessionAuthService: SessionAuthService
  ) {
    const boot = this.bootStateService.snapshot;
    this.currentSessionId = boot.sessionId ?? uuidv4();
    this.hydrateFromBootState(boot);
    this.isAndroidPlatform = this.deviceService?.os?.toLowerCase() === 'android';
    if (this.isAndroidPlatform) {
      document.documentElement.classList.add('gfh-android');
    }
    markLoad('chatbot_component_constructed');
  } //end constructor

  private logLoadSummary(finalMark: string, extra?: Record<string, unknown>): void {
    const summary = getLoadTimingSummary();
    const payload = {
      finalMark,
      marks: summary,
      bootShellShownAtMs: window.__GFH_BOOT_SHELL_SHOWN_AT__ ?? null,
      ...extra,
    };
    this.clientLogService.log('info', 'LOAD', `Startup complete: ${finalMark}`, payload);
  }

  private readonly landingBackgroundUrl = 'assets/img/ai-chat/chat-bg.png';

  private preloadLandingAssets(): void {
    void this.waitForLandingAssets();
  }

  private waitForLandingAssets(): Promise<void> {
    const urls = [this.landingBackgroundUrl];
    markLoad('landing_assets_wait_start', { urls });

    return Promise.all(
      urls.map((url) => {
        const startedAt = performance.now();
        return new Promise<void>((resolve) => {
          const img = new Image();
          img.onload = () => {
            markLoad('landing_asset_loaded', {
              url,
              assetMs: Math.round(performance.now() - startedAt),
              ok: true,
            });
            resolve();
          };
          img.onerror = () => {
            markLoad('landing_asset_loaded', {
              url,
              assetMs: Math.round(performance.now() - startedAt),
              ok: false,
            });
            resolve();
          };
          img.src = url;
        });
      })
    ).then(() => {
      markLoad('landing_assets_wait_done');
    });
  }

  private scheduleEntryAnimations(): void {
    if (this.landingAnimationsReady$.value) {
      return;
    }

    markLoad('entry_animation_scheduled', {
      hasCachedContent: this.messagesSubject.getValue().length > 0,
    });

    if (this.entryAnimationFrameId !== null) {
      cancelAnimationFrame(this.entryAnimationFrameId);
    }

    const hasCachedContent = this.messagesSubject.getValue().length > 0;
    const reveal = () => {
      markLoad('entry_animation_reveal_start', { hasCachedContent });
      const frameCount = hasCachedContent ? 1 : 2;

      const finishReveal = () => {
        this.entryAnimationFrameId = null;
        document.documentElement.classList.add('gfh-app-ready');
        this.landingAnimationsReady$.next(true);
        this.entryVeilHidden$.next(true);
        markLoad('app_ready');
        this.logLoadSummary('app_ready');
        window.setTimeout(() => {
          markLoad('boot_shell_removed');
          this.removeBootShellOverlay();
        }, 600);
      };

      const waitFrames = (remaining: number) => {
        this.entryAnimationFrameId = requestAnimationFrame(() => {
          if (remaining <= 1) {
            finishReveal();
            return;
          }
          waitFrames(remaining - 1);
        });
      };

      waitFrames(frameCount);
    };

    if (hasCachedContent) {
      markLoad('landing_assets_skipped_cached_content');
      reveal();
      return;
    }

    void this.waitForLandingAssets().then(reveal);
  }

  private removeBootShellOverlay(): void {
    document.getElementById('gfh-boot-shell')?.remove();
  }

  private bindVisualViewportLayout(): void {
    const vv = window.visualViewport;
    if (!vv) {
      return;
    }

    const update = (): void => {
      const keyboardInset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      const keyboardOpen = keyboardInset > 50;

      document.documentElement.style.setProperty('--gfh-keyboard-inset', `${keyboardInset}px`);
      document.documentElement.style.setProperty('--gfh-vv-offset-top', `${vv.offsetTop}px`);
      document.documentElement.style.setProperty('--gfh-vv-height', `${vv.height}px`);
      document.documentElement.classList.toggle('gfh-keyboard-open', keyboardOpen);

      if (keyboardOpen) {
        this.resetPageScrollForKeyboard();
      }
    };

    this.visualViewportUpdate = update;

    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    update();

    this.visualViewportCleanup = () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      this.visualViewportUpdate = undefined;
      document.documentElement.classList.remove('gfh-keyboard-open');
      document.documentElement.style.removeProperty('--gfh-keyboard-inset');
      document.documentElement.style.removeProperty('--gfh-vv-offset-top');
      document.documentElement.style.removeProperty('--gfh-vv-height');
    };
  }

  private isMobileChatViewport(): boolean {
    const deviceType = this.deviceService?.deviceType?.toLowerCase();
    return deviceType === 'mobile'
      || deviceType === 'tablet'
      || window.innerWidth <= 600;
  }

  private resetPageScrollForKeyboard(): void {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  private hydrateFromBootState(boot: BootState): void {
    if (boot.token) {
      this.token = boot.token.trim();
    }

    const canTrustQueryCif = environment.allowAdminUrlFlags || !!(this.token || boot.token);
    if (boot.cif && canTrustQueryCif) {
      this.cif = boot.cif;
      this.isSessionReady$.next(true);
      this.isChatbotAccessible$.next(true);
    }

    if (boot.userName) {
      this.currentUserName = boot.userName;
    }

    if (boot.kmMeta) {
      localStorage.setItem('km_meta', boot.kmMeta);
    }

    this.applyFeatureFlags(boot.featureFlags);

    const cachedMessages = loadCachedSession<ChatMessage>(this.currentSessionId);
    if (cachedMessages?.length) {
      this.messagesSubject.next(cachedMessages);
      this.showLandingScreen$.next(false);
    }
  }

  private applyFeatureFlags(flags: BootState['featureFlags'] = {}): void {
    if (environment.allowAdminUrlFlags) {
      if (flags.isAppAdmin !== undefined) {
        this.isAppAdmin = flags.isAppAdmin;
      }
      if (flags.isToRecordToFile !== undefined) {
        this.isToRecordToFile = flags.isToRecordToFile;
      }
      if (flags.showAdminDebugBanner !== undefined) {
        this.isShowAdminUIControls = flags.showAdminDebugBanner;
      }
    }
    if (flags.conversationalAgent) {
      this.isConversationalAgent$.next(true);
    }
  }

  private restoreCachedSessionIfAvailable(): void {
    const cachedMessages = loadCachedSession<ChatMessage>(this.currentSessionId);
    if (!cachedMessages?.length) {
      return;
    }

    this.messagesSubject.next(cachedMessages);
    this.showLandingScreen$.next(false);
  }

  private persistSessionCache(messages: ChatMessage[]): void {
    if (!this.currentSessionId || !messages.length) {
      return;
    }

    saveCachedSession(this.currentSessionId, messages);
  }

  private deferSessionHistoryFetch(): void {
    const params = new URLSearchParams(window.location.search);
    const hostSessionId = params.get('sessionId')?.trim() || params.get('session_id')?.trim();
    const hasCachedMessages = !!loadCachedSession<ChatMessage>(this.currentSessionId)?.length;
    const shouldFetchHistory = !!hostSessionId || hasCachedMessages;

    if (!shouldFetchHistory) {
      markLoad('session_history_fetch_skipped');
      return;
    }

    markLoad('session_history_fetch_scheduled', { hostSessionId: !!hostSessionId, hasCachedMessages });
    this.bootStateService.runAfterFirstPaint(() => {
      if (this.messagesSubject.getValue().length > 0) {
        markLoad('session_history_fetch_skipped_existing_messages');
        return;
      }

      const startedAt = performance.now();
      markLoad('session_history_fetch_start');
      this.getChatHistory().subscribe({
        next: (data) => {
          markLoad('session_history_fetch_done', {
            durationMs: Math.round(performance.now() - startedAt),
            messageCount: data?.length ?? 0,
          });
          this.applyHistoryMessages(data);
        },
        error: (error) => {
          markLoad('session_history_fetch_error', {
            durationMs: Math.round(performance.now() - startedAt),
          });
          console.error('Error fetching chat history:', error);
        },
      });
    });
  }

  private applyHistoryMessages(data: ChatMessage[]): void {
    if (!data?.length) {
      return;
    }

    this.messagesSubject.next([]);
    data.forEach((message) => {
      const rawText = message?.text || '';
      const normalizedHistory = this.prepareStreamTextForDisplay(rawText);
        if (chartFromTextParser.hasMarkdownTable(normalizedHistory)) {
        let extractedMDTable = this.extractMarkdownTable(normalizedHistory);
        message.text = this.renderChatMessageHtml(rawText);

        const chartableTable = this.findChartableTable(extractedMDTable, message.text);
        if (chartableTable) {
          const chartConfig = chartFromTextParser.generateEChartsConfig(chartableTable);
          if (chartConfig) {
            this.echartOptions.push(
              { key: message.id, value: chartConfig, optionality: { height: 400 } }
            );
          }
        }
      }

      message.currentTime = this.getCurrentFormattedDateTime(message.currentTime);
      this.addMessage(message);
    });

    this.showLandingScreen$.next(false);
    this.persistSessionCache(this.messagesSubject.getValue());
  }

  private async validateAuthFromToken(token: string): Promise<void> {
    if (!token || this.authValidationStarted) {
      return;
    }

    this.authValidationStarted = true;
    this.isTokenValidating$.next(true);
    this.showAuthError$.next(false);
    this.isChatbotAccessible$.next(true);

    const authStartedAt = performance.now();
    markLoad('auth_validation_start');

    const encryptedSub = this.jwtService.processJwt(token);
    if (!encryptedSub) {
      debugLog.error('auth/session', 'Portal token has no encrypted sub claim; cannot start a session', { hasToken: !!token });
      markLoad('auth_validation_failed', { reason: 'missing_encrypted_sub' });
      this.isTokenValidating$.next(false);
      this.isChatbotAccessible$.next(false);
      this.showAuthError$.next(true);
      return;
    }

    try {
      const sessionResponse = await this.sessionAuthService.exchangePortalToken(token, this.botConversationMode);
      this.cif = sessionResponse.cif || '';
      this.currentUserName = sessionResponse.user_name || '';
      if (sessionResponse.km_meta) {
        localStorage.setItem('km_meta', sessionResponse.km_meta);
      }
      this.isSessionReady$.next(true);
      this.isChatbotAccessible$.next(true);
      this.showAuthError$.next(false);
      markLoad('auth_validation_done', {
        durationMs: Math.round(performance.now() - authStartedAt),
        ok: true,
      });
      this.bootStateService.patch({
        token,
        cif: this.cif,
        userName: this.currentUserName,
        kmMeta: sessionResponse.km_meta,
      });
      debugLog.setState('chat', {
        sessionId: this.currentSessionId,
        hasCif: !!this.cif,
        hasUserName: !!this.currentUserName,
        conversationMode: this.botConversationMode,
        authOk: true,
      });
    } catch (error) {
      markLoad('auth_validation_done', {
        durationMs: Math.round(performance.now() - authStartedAt),
        ok: false,
        status: error?.status,
      });
      const isNetworkError = !error?.status || error?.status === 0;
      debugLog.error('auth/session', 'Failed to exchange portal token for a session', {
        ...debugLog.describeHttpError(error),
        apiUrl: environment.apiUrl,
        hasToken: !!token,
        hasEncryptedSub: !!encryptedSub
      });
      if (error?.error?.detail && String(error.error.detail).includes("Token already exists")) {
        this.errorCode4Chars = "0901";
      }
      debugLog.setState('chat', {
        sessionId: this.currentSessionId,
        conversationMode: this.botConversationMode,
        authOk: false,
        authStatus: error?.status ?? null,
        authDetail: error?.error?.detail ?? null,
      });
      if (isNetworkError) {
        console.warn('Auth API unreachable (status 0: network/TLS/CORS). Locally, start the backend on port 8020.', error);
        this.isChatbotAccessible$.next(true);
        this.showAuthError$.next(false);
      } else {
        this.isChatbotAccessible$.next(false);
        this.showAuthError$.next(true);
      }
    } finally {
      this.isTokenValidating$.next(false);
    }
  }

  ngOnDestroy():void {
    if (this.entryAnimationFrameId !== null) {
      cancelAnimationFrame(this.entryAnimationFrameId);
      this.entryAnimationFrameId = null;
    }
    this.visualViewportCleanup?.();
    this.visualViewportCleanup = undefined;
    document.documentElement.classList.remove('gfh-landing');
    document.documentElement.classList.remove('gfh-chat-active');
    document.documentElement.classList.remove('gfh-android');
    // this.audioCaptureService.cleanup();
    if (this.eventSource) {
      this.eventSource.close();
    }

    // Ensure internalSub exists before unsubscribing
    if (this.internalSub) {
        this.internalSub.unsubscribe();
    }
  }


  async ngOnInit(): Promise<void> {
    markLoad('chatbot_ngOnInit_start');
    this.clientLogService.log('info', 'LOAD', 'Chatbot init started', {
      environment: this.currentEnvironment,
      apiUrl: environment.apiUrl,
    });

    this.route.queryParamMap.subscribe((params) => {
      const queryToken = params.get('token')?.trim();
      if (queryToken) {
        this.token = queryToken;
      }

      const querySessionId = params.get('sessionId')?.trim() || params.get('session_id')?.trim();
      if (querySessionId && querySessionId !== this.currentSessionId) {
        this.currentSessionId = querySessionId;
        this.restoreCachedSessionIfAvailable();
      }

      this.bootStateService.patch({
        token: this.token || undefined,
      });
      if (this.isAppAdmin) {
        this.isChatbotAvailable$.next(true);
      }
    });

    this.internalSub.add(
      this.bootStateService.boot$.subscribe((boot) => {
        this.hydrateFromBootState(boot);
        if (boot.token && boot.token !== this.token) {
          this.token = boot.token;
          this.bootStateService.runAfterFirstPaint(() => {
            void this.validateAuthFromToken(this.token);
          });
        }
      })
    );

    this.internalSub.add(
      this.messages$.subscribe((messages) => {
        const onLanding = messages.length === 0;
        document.documentElement.classList.toggle('gfh-landing', onLanding);
        document.documentElement.classList.toggle('gfh-chat-active', !onLanding);

        if (messages.length > 0) {
          this.showLandingScreen$.next(false);
          this.persistSessionCache(messages);
        }
      })
    );

    if (this.currentEnvironment !== EnvironmentTypeEnum.PROD.toString()
      && this.currentEnvironment !== EnvironmentTypeEnum.PPE.toString()) {
      this.isAdmin = true;
      this.isShowAdminUIControls = environment.showAdminDebugBanner !== false;
    }

    console.log("Current Session ID ::: " + this.currentSessionId);

    if (((this.deviceService?.deviceType?.toLowerCase() === "mobile" || this.deviceService?.deviceType?.toLowerCase() === "tablet") &&
      (this.deviceService?.os?.toLowerCase() === "android" || this.deviceService?.os?.toLowerCase() === "ios"))
      || this.isAdmin) {
      this.isChatbotAvailable$.next(true);
    }

    this.preloadLandingAssets();
    this.scheduleEntryAnimations();
    this.bindVisualViewportLayout();
    this.deferSessionHistoryFetch();
    markLoad('chatbot_ngOnInit_setup_done');

    if (this.token && !this.cif) {
      this.bootStateService.runAfterFirstPaint(() => {
        void this.validateAuthFromToken(this.token);
      });
    } else if (!this.token && !this.cif) {
      this.bootStateService.runAfterFirstPaint(() => {
        if (!this.token && !this.cif) {
          this.isChatbotAccessible$.next(false);
          this.showAuthError$.next(true);
        }
      });
    } else {
      this.isSessionReady$.next(true);
    }

    // let _strTest = `
    // | Project Name | Portfolio Performance (%) | Expected Return (%) |
    // |-----------------------|---------------------------|---------------------|
    // | Britus | 110.0 | 80.0 |
    // | Medical Clinics II | 110.0 | 55.0 |
    // | Student Housing II | 105.0 | 60.0 |
    // `

    // const content = `
    // asdfsdf

    //   | Project Name | Portfolio Performance (%) | Expected Return (%) |
    //   |-----------------------|---------------------------|---------------------|
    //   | Britus | 110.0 | 80.0 |
    //   | Medical Clinics II | 110.0 | 55.0 |
    //   | Student Housing II | 105.0 | 60.0 |

    //   asdfsadf
    //       `;

    // // Marked.setOptions ({
    // //   renderer: new Renderer,
    // //   gfm: true,
    // //   tables: true,
    // //   breaks: false,
    // //   pedantic: false,
    // //   sanitize: false,
    // //   smartLists: true,
    // //   smartypants: false
    // // });

    // // this.strTest = Marked.parse(_strTest);

    // // console.log(Marked.parse(_strTest));
    // // console.log(Marked.parse('I am using __markdown__.'));

    // if (chartFromTextParser.hasMarkdownTable(content)) {



      // let htmlStringTest = `
      //   This is the time, do you see this md table..

      //   | Sector | Total Invested (USD) |
      //   |-----------------------|----------------------|
      //   | Cash | $448,540.00 |
      //   | Loyalty Program | $2,653.00 |
      //   | Loyalty Program Discount | $2,653.00 |
      //   | Private Equity | $6,100,199.00 |
      //   | Restricted Credit | $7.00 |
      //   | Real Estate | $7,466,400.00 |

      //   Table confirmed in MD. this is the bottom...
      //   `;


        // let htmlStringTest = `
        // This is the time, do you see this md table..

        // | Sector                  | Amount (USD) | Percentage Allocated Within Portfolio |
        // |-------------------------|--------------|---------------------------------------|
        // | Cash                    | 448,540.00   | 3.2                                  |
        // | Educational Services    | 500,000.00   | 3.57                                 |
        // | Healthcare              | 665,000.00   | 4.74                                 |
        // | Infrastructure          | 3,235,199.00 | 23.07                                |
        // | Logistics               | 1,500,000.00 | 10.7                                 |
        // | Loyalty Program         | 2,653.00     | 0.02                                 |
        // | Loyalty Program Discount| 2,653.00     | 0.02                                 |
        // | Manufacturing           | 200,000.00   | 1.43                                 |
        // | Others                  | 600,000.00   | 4.28                                 |
        // | Real Estate             |  | 48.93                                |
        // | Restricted Credit       | 7.00         | 0.0                                  |
        // | Student Accommodation   | abc     | 0.05                                 |

        // [*]

        // Table confirmed in MD. this is the bottom...
        // `;


      //---------------table detection
      // let htmlStringTest = `
      // Certainly, here is a list of your current projects:

      // | Project Name |
      // |-----------------------|
      // | Medical Clinics II |
      // | Student Housing III |
      // | Saudi S. Hospital |
      // | US Living Debt |

      // [*] See the table for details.

      // - Real Estate (RE): 64.32%
      // - Private Equity (PE): 24.66%
      // - Working Capital (WK): 14.06%
      // - Managed Assets (MA): 2.67%
      // - Cash Account (CA): -5.7%
      // `

      // console.log("show the md table is a match or not");
      // console.log(chartFromTextParser.hasMarkdownTable(htmlStringTest));

      // console.log("show the table is a convertable list to MD table is a match or not");
      // console.log(chartFromTextParser.hasMultipleInvestments(htmlStringTest));


      // // console.log(markdown.markdown(htmlStringTest));
      // console.log("finalizing call to produce table...");

      // let extractedMDTable = this.extractMarkdownTable(htmlStringTest);

      // console.log(extractedMDTable);

      // let extractedMDTableCleanedUp = extractedMDTable[0].replace(/<br\/>/gi, "\n"); //removes any breaks from the table

      // console.log("cleaned up table...");
      // console.log(extractedMDTableCleanedUp);
      //---------------table setup for detection below ^^^



      // const lines = extractedMDTableCleanedUp.trim().split('\n').filter(line => line.trim());
      // console.log("...working on item...");


      // let isAnyMetricInTable = false;
      // // NB: if not found the % then value will be -1
      // const linesOut = lines.slice(2).map(line => {

      //   const index = lines.findIndex(line => line.includes("%"));
      //   console.info(index);


      //   console.info(line.trim().split('|').filter(cell => cell !== '').map(cell => cell.trim()));
      //   return line.trim().split('|').filter(cell => cell !== '').map(cell => cell.trim());
      // });

      // console.info("line out", linesOut);





      // let parsedObj = this.parseMarkdownTableToObjArray(extractedMDTableCleanedUp, '');
      // console.log("here is the found table OBJECT", parsedObj);

      // let parsedObjArray = this.parseMarkdownTable(extractedMDTableCleanedUp, '', false);

      // this.tableOptions.push(
      //   {key: 1, valueArray: parsedObjArray, optionality: {}}
      // );




      // // for(const[k,v] of this.tableOptions.entries().valueArray){
      // //   console.log(k, v);
      // // }

      // this.tOptionsIdx = this.tableOptions.find(i => i.key == 1);

      // for(let row of this.tOptionsIdx.valueArray) {
      //   console.log("item:", row);
      // }

      // let lenOfOriginalTableData = parsedObj.length;
      // console.log("length of the table data", lenOfOriginalTableData);

      // let filteredData = parsedObj
      //   .filter(item => typeof this.convertStringToNumber(item?.['value']) === "number");

      // console.log("info on filtered data (orig leng:", lenOfOriginalTableData, filteredData.length, filteredData);


      // // create the chart
      // const chartConfig = chartFromTextParser.generateEChartsConfig(parsedObj);
      // console.info("charting options config", chartConfig);
      // let eChartOption = chartConfig;

      // this.echartOptions.push(
      //   {key: 0, value: eChartOption, optionality: {height: 400}}
      // )


      // let parsedObjArray2 = this.parseMarkdownTable(extractedMDTableCleanedUp, '');
      // console.log("here is the found table OBJECT", parsedObjArray);



      // // let _tableToObject: any = this.tableToObject(parsedObjArray2);
      // // console.log("parsed table to object", _tableToObject);
      // // console.log("Name of Item:", _tableToObject[3]?.name);
      // // console.log("Value of Item:", _tableToObject[3]?.value);




      //---------------table detection
      // const tablePattern = chartFromTextParser.TABLE_DETECTION_PATTERN;

      // const newStr = htmlStringTest.replace(tablePattern, markdown.markdown(extractedMDTableCleanedUp)); // Replace all "Hello" with "Hi"

      // htmlStringTest = newStr;

      // console.log("...", newStr);










    //   console.info("---------yes it for table mkdown");
    //   // const performances = chartFromTextParser.parsePerformanceTable(content);
    //   // console.log(performances);
    //   // const chartConfig = chartFromTextParser.generateEChartsConfig(performances);
    //   // Initialize eCharts with the config

    //   // const parsedTable = chartFromTextParser.parseTable(content);
    //   // console.log(parsedTable.headers); // ['Project', 'Performance (%)', 'Return (%)', 'Status']
    //   // console.log(parsedTable.rows); // Array of row objects with header keys

    //   // If you just want the raw data rows
    //   // const dataRows = chartFromTextParser.parseDataRows(content);
    //   // console.log(dataRows);
    // }
    // else {
    //   console.log("***NO JOY");
    // }


    // // Subscribe to state changes
    // this.audioCaptureService.getState().subscribe(state => {
    //   console.log('Audio capture state:', state);
    // });

    // // Subscribe to errors
    // this.audioCaptureService.getError().subscribe(error => {
    //   if (error) {
    //     console.error('Audio capture error:', error);
    //   }
    // });

    // // Subscribe to audio data
    // this.audioCaptureService.getAudioData().subscribe(audioBytes => {
    //   // Handle the audio bytes
    // });



  }


  // getPermissions is used to access the permissions API
  // This API is not fully supported in all browsers so we first check the availability of the API
  async getPermissions(): Promise<string> {
    if (!!navigator?.permissions) {
      return (
        // - ignore because microphone is not in the enum of name for all browsers
        // @ts-ignore
        navigator.permissions?.query({ name: 'microphone' })
          .then((result) =>
            result.state + "<" || "promptx"
          )
          .finally(()=>{
            return 'finally'
          })
          .catch((err) => {
            return 'prompty';
          })
      );
    }
    return 'promptz';
  }




  // ngAfterViewInit(): void {
  async ngAfterViewInit(): Promise<void> {

    ////this.handlePermission();

    // NB: print out the device information
    console.info("Browser Info:", JSON.stringify(this.deviceService));


    // added this method to show list of devices available when Mic privilege is allowed
    this.textToSpeechService.listDevices();

    this.textToSpeechService.state$.subscribe((x) => {
      //console.log("tts state", x);
      this.isAudioTTOSPlaying$.next(x.isPlaying);
    })

    //this.connectToSSE();

    this.privInfo = this.getPermissions(); //await navigator.permissions.query({name: "microphpone"})

    if(this.deviceService?.deviceType?.toLowerCase()=="mobile" && this.deviceService?.browser?.toLowerCase()=="safari"){
      //this.privInfo = this.deviceService?.deviceType;
      this.isMobileSafariEnv = true;
    }

    // this.streamOfTextToPollyAudio.subscribe({
    //   next: (base64Audio: string) => {
    //     this.playAudioResponse(base64Audio);
    //     // Create audio source from base64 data
    //     // const audioDataUrl = `data:audio/mp3;base64,${base64Audio}`;
    //     // this.audioSource = this.sanitizer.bypassSecurityTrustUrl(audioDataUrl);
    //     // this.isLoading = false;
    //   },
    //   error: (error: any) => {
    //     // this.error = 'Error generating audio: ' + error.message;
    //     // this.isLoading = false;
    //   }
    // });


    // await this.doStreamAudioTest("testing the solution right now").then(() => {
    // });


    //this.startAudioRecording();



    //testing for live speech to text streaming -----------------
    //this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();


    //this.generateSpeech("hello world");



    /**
     Issues because in Angular of FrontEnd UI this javascript is NOT supported, it requires a BUFFER and FileSystem access
     * main.ts:6 ERROR DeepgramError: Due to CORS we are unable to support REST-based API calls to our API from the browser. Please consider using a proxy: https://dpgr.am/js-proxy for more information.
    at new AbstractRestClient (AbstractRestClient.js:47:13)
    at new SpeakRestClient (SpeakRestClient.js:36:5)
    at SpeakClient.request (SpeakClient.js:20:20)
     */
  // dgConnectionSpeak.on(LiveTTSEvents.Open, () => {
  //   console.log("Connection opened");

  //   // Send text data for TTS synthesis
  //   dgConnectionSpeak.sendText("how can I argue with you when you're always the best.");

  //   // Send Flush message to the server after sending the text
  //   dgConnectionSpeak.flush();

  //   dgConnectionSpeak.on(LiveTTSEvents.Close, () => {
  //     console.log("Connection closed");
  //   });

  //   dgConnectionSpeak.on(LiveTTSEvents.Metadata, (data) => {
  //     console.log(data, { depth: null });
  //   });

  //   dgConnectionSpeak.on(LiveTTSEvents.Audio, (data) => {
  //     console.log("Deepgram audio data received");

  //     // Concatenate the audio chunks into a single buffer
  //     console.info("streaming data", data);

  //     // const buffer = Buffer.from(data);
  //     // audioBuffer = Buffer.concat([audioBuffer, buffer]);
  //   });

  //   dgConnectionSpeak.on(LiveTTSEvents.Flushed, () => {
  //     console.log("Deepgram Flushed");
  //     // Write the buffered audio data to a file when the flush event is received
  //     //writeFile();
  //   });

  //   dgConnectionSpeak.on(LiveTTSEvents.Error, (err) => {
  //     console.error(err);
  //   });
  // });

  // const text = 'taking it to the next limit we are';

  // const responseSpeak = await deepgramClient.speak.request({text}, { model: "aura-asteria-en"});





    ////this.doAudioWaveAnimations();
    // // Initialize visualization association
    // this.svgAudioWaveCircle = this.circleAudioWavesOverlayEl.nativeElement;



    //.....testing...........
    // let stringTest = `
    // Your current portfolio balance is as follows:

    // <ul>
    //     <li><b>Europe:</b> $3,235,199 USD</li>
    //     <li><b>GCC:</b> $3,618,853 USD</li>
    //     <li><b>USA:</b> $7,166,400 USD</li>
    // </ul>

    // The total portfolio size across all regions is <b>$14,020,452 USD</b>.
    // `;

    // this.addMessage(new ChatMessage(this.chatMessageId,
    //   MessageSenderTypeEnum.user,
    //   "who is captain marvel?",
    //   MessageTypeEnum.TEXT.toString(),
    //   this.getCurrentFormattedTime(),
    //   '',
    //   ''
    // ));

    // this.addMessage(new ChatMessage(this.chatMessageId,
    //   MessageSenderTypeEnum.bot,
    //   stringTest,
    //   MessageTypeEnum.TEXT.toString(),
    //   this.getCurrentFormattedTime(),
    //   '',
    //   ''
    // ));




  } // end ngAfterViewInit method

  /**
   * Meant to provide a process for showing animated waves as an svg that reacts to the microphone
   */
  doAudioWaveAnimations() {
    // Stop and clear the previous instance if it exists
    if (this.waveCircleClassObj) {
      this.waveCircleClassObj.stop(); // Stop the interval
      this.waveCircleClassObj.undraw(); // Remove the drawn SVG elements
    }

    // Instantiate the object
    this.waveCircleClassObj = new AudioWaveCircle(this.svgAudioWaveCircle, {
        radius: 48,
        points: 64,
        maxAmplitude: 60,
        strokeColor: 'red',
        strokeWidth: 2,
        smoothing: 0.85,
        updateInterval: 30 // Update every 50ms
    });

    // Start the visualization
    this.waveCircleClassObj.start();

    //let audioData = this.waveCircleClassObj.simulateAudioData();
    //this.waveCircleClassObj.update();

    // //auto timeout the wave functionality and stop with the deepgram/transcriber
    // setTimeout((x) => {
    //     console.log("wave circle stop------------------------");
    //     this.waveCircleClassObj.amplitude = 1;
    //     this.waveCircleClassObj.stop();
    //     this.waveCircleClassObj.undraw();
    // }, this.final__audio_wave_animation_timeout_ms);

  }




  /**
   * Returns a SSE stream Observable to subscribe to
   * @param question
   * @returns
   */
  private getChatResponseStream(question: string): Observable<any> {
    const payload = { question };
    // const headers = new HttpHeaders().set('X-GFH-AI-CHATBOT-CIF', `${this.cif}`);
    const headers = new HttpHeaders({
      ...getApiAuthHeaders({
        'X-GFH-AI-CHATBOT-CIF': this.cif,
        'X-GFH-AI-CHATBOT-SESSION-ID': this.currentSessionId
      })
    });

    console.log("Here is the main user input question going to api", payload);

    debugLog.info('chat/request', 'Sending chat question to API', {
      endpoint: this.apiUrl + '/test_ask_question2',
      hasCif: !!this.cif,
      cifLength: this.cif ? String(this.cif).length : 0,
      hasSessionId: !!this.currentSessionId
    });

    // return the stream Observable
    return this.sseClient.stream(this.apiUrl + '/test_ask_question2',
      { keepAlive: true,
        reconnectionDelay: 1_000,
        responseType: 'event'
      },
      { body: payload, headers: headers },
      'POST')
  }




  sendCommonQuestion(question: string): void {
    this.contextualSuggestions = [];
    this.userInput$.next(question);
    this.sendMessageGetStream(question);
  }



  sendMessage(e) {
    if (!this.userInput$.getValue().trim()) return;

    const question = this.offensiveFilter.clean(this.userInput$.getValue().trim());
    this.contextualSuggestions = [];

    var userMessage = new ChatMessage(this.chatMessageId,
      MessageSenderTypeEnum.user,
      question,
      MessageTypeEnum.TEXT.toString(),
      this.getCurrentFormattedDateTime(),
      '',
      ''
    );

    this.addMessage(userMessage);

    this.userInput$.next('');
    this.isDeleteUserInputOptionAvailable$.next(false);

    this.isTyping = true; // Show typing indicator

    setTimeout(() => this.scrollToBottom(), 0);

    let requestStartTime = performance.now();
    this.getChatResponse(question)
      .pipe(
        //delay(1000), // Simulate typing delay
        tap((response) => {
          const elapsedTime = performance.now() - requestStartTime; // Calculate elapsed time
          const formattedElapsedTime = this.formatElapsedTime(elapsedTime);

          this.isTyping = false; // Hide typing indicator

          var chatResponse = new ChatMessage(this.chatMessageId,
            MessageSenderTypeEnum.bot.toString(),
            response.answer,
            MessageTypeEnum.TEXT.toString(),
            this.getCurrentFormattedDateTime(),
            response.source,
            formattedElapsedTime
          );
          this.addMessage(chatResponse);
          this.contextualSuggestions = this.generateContextualSuggestions(question, response.answer || '');
        }),
        catchError((error) => {
          const elapsedTime = performance.now() - requestStartTime; // Calculate elapsed time
          const formattedElapsedTime = this.formatElapsedTime(elapsedTime);
          this.isTyping = false; // Hide typing indicator


          //NB: Check if the CIF is entered  **** otherwise you will get this message for sure when testing
          var chatErrResponse = new ChatMessage(this.chatMessageId,
            MessageSenderTypeEnum.bot.toString(),
            'Something went wrong. Please try again.',
            MessageTypeEnum.TEXT.toString(),
            this.getCurrentFormattedDateTime(),
            '',
            formattedElapsedTime
          );
          this.addMessage(chatErrResponse);
          return of(error);
        })
      )
      .subscribe(() => setTimeout(() => this.scrollToBottom(), 0));
  }


  // generateBotResponse(message: string) {
  //   const botReply = `AI: You said "${message}"`;
  //   var botResponse = new ChatMessage(this.chatMessageId,
  //     MessageSenderTypeEnum.bot.toString(),
  //     botReply,
  //     MessageTypeEnum.TEXT.toString(),
  //     this.getCurrentFormattedTime(),
  //     '',
  //     ''
  //   );

  //   this.messages.push(botResponse);

  //   setTimeout(() => this.scrollToBottom(), 0);
  // }


  private addMessage(message: ChatMessage) {
    //this.messages.push(message);
    const currentMessages = this.messagesSubject.getValue();
    this.messagesSubject.next([...currentMessages, message]);

    if(message.sender == MessageSenderTypeEnum.user.toString()) {
      this.chatMessageId++;
    }
  }


  private updateMessage (currentMessages, updatedMessage, messageSender) {
    const index = currentMessages.findIndex((m) => m.id === updatedMessage.id && m.sender == messageSender);

    if (index !== -1) {
      currentMessages[index] = updatedMessage;
    }

    return currentMessages;
  };


  private getChatResponse(question: string): Observable<any> {
    const payload = { question };
    const headers = new HttpHeaders({
      'X-GFH-AI-CHATBOT-CIF': this.cif,
    });

    console.log("HEre is  the payload question", payload);

    return this.http.post<any>(this.apiUrl + '/ask_question', payload, {
      headers,
    });
  }



  async getDecryptedCIF(encrypted_value: string, token: string, bot_conv_type: string): Promise<any> {
    const requestStartTime = performance.now();
    try {
      const response: any = await firstValueFrom(this.getDecryptedTokenResponse(encrypted_value, token, bot_conv_type));
      const elapsedTime = performance.now() - requestStartTime;
      const formattedElapsedTime = this.formatElapsedTime(elapsedTime);

      console.log(`Decrypted Response timelapse ${formattedElapsedTime}`);
      return response;
    }
    catch (error) {
      const elapsedTime = performance.now() - requestStartTime;
      const formattedElapsedTime = this.formatElapsedTime(elapsedTime);

      console.error(`Error: ${error}, Time Taken: ${formattedElapsedTime}`, error);
      debugLog.error('auth/decrypt_token', 'decrypt_token request failed', {
        ...debugLog.describeHttpError(error),
        timeTaken: formattedElapsedTime
      });

      if(error?.error?.detail && error?.error?.detail.includes("Token already exists")){
        this.errorCode4Chars = "0901";
      }

      throw error;
    }
  }



  private getDecryptedTokenResponse(encrypted_value: string, token: string, bot_conv_type: string): Observable<any> {
    const payload = { encrypted_value, token, bot_conv_type };

    return this.http.post<any>(this.apiUrl + '/decrypt_token', payload);
  }


  private getVoiceResponsePerClient(question: string): Observable<any> {
    const payload = { question };
    const headers = new HttpHeaders({
      'X-GFH-AI-CHATBOT-CIF': `${this.cif}`,
    });
    return this.http.post(`${this.apiUrl}/speak_ttv`, payload, {
      headers,
    });
  }


  private getVoiceResponsePerClientStreaming(textToSpeak: string): Observable<any> {
    const payload = textToSpeak;
    const headers = new HttpHeaders({
      'X-GFH-AI-CHATBOT-CIF': `${this.cif}`,
    });
    return this.http.post(`${this.apiUrl}/speak_ttov_streaming`, payload, {
      headers,
    });
  }


  private getVoiceChatResponse(question: string): Observable<any> {
    const payload = { question };
    const headers = new HttpHeaders({
      'X-GFH-AI-CHATBOT-CIF': this.cif,
    });
    return this.http.post(`${this.apiUrl}/ask_question_ttv`, payload, {
      headers,
    });
  }


  // playAudioResponse(base64Audio: string) {
  //   // Stop any currently playing audio
  //   this.stopAudio(null, null);

  //   // Convert Base64 string to a Blob
  //   const binary = atob(base64Audio);//atob(base64Audio.replace(/\s/g, ''));
  //   const array = new Uint8Array(binary.length);
  //   for (let i = 0; i < binary.length; i++) {
  //     array[i] = binary.charCodeAt(i);
  //   }
  //   const blob = new Blob([array], { type: 'audio/mpeg' });

  //   // Create a URL for the Blob and play the audio
  //   const audioUrl = URL.createObjectURL(blob);
  //   this.audio = new Audio(audioUrl); // Store reference to audio

  //   // Add an event listener to detect when the audio finishes playing
  //   this.audio.addEventListener('ended', () => {
  //     this.audio = null; // Clear the reference
  //     this.isAudioPlaybackStarted$.next(false);
  //   });

  //   this.isAudioPlaybackStarted$.next(true);
  //   this.audio.play().catch((error) => {
  //     console.error('Audio playback failed:', error);
  //     this.isAudioPlaybackStarted$.next(false);
  //   });
  // }


  /**
   * Stops Audio from playing and based on conditions will do other clean-up, etc. tasks
   * Inputs that need to be stopped or reset, using this method:
   *  1. arrow/send question manually => method to send calls this method with null, null arguments. input cleared in send method
   *  2. mic button =>
   * @param e Event arg from UI otherwise, null
   * @param areaOfApp Describes which area of the app this call to stopAudio is coming
   */
  stopAudio(e, areaOfApp) {

    //prevent the STOT transcribe auto send
    clearTimeout(this.autoSendFromTranscribeTimeout);


    // close the port if audio stopped
    if(this.audioWorkletNode?.port){
      this.audioWorkletNode.port.close();
    }

    // reset tmp placeholder
    this.tmp__ui_user_input_placehoder_text = this.final__ui_user_input_placehoder_text;
    this.isSendReady$.next(false);


    // basically resets the input back to showing place holder
    if(this.userInput$.value == this.final__speak_now_text){
      this.userInput$.next('');
      this.isDeleteUserInputOptionAvailable$.next(false);
    }

    // resets the recording waves to display none
    this.isSpeechListening$.next(false);

    // stopping/resets the spinning audio, etc. icon, etc.
    this.isWaitingForMicAudioOrSocket$.next(false);

    if(audioCaptureSub){
      audioCaptureSub.unsubscribe();
    }

    //stop standard WS main transcribe mic, stops mic
    this.stopDeepgramWSStreaming();

    if(areaOfApp=="stop_bot_speaking"){
      console.log("in stop ----- bot speaking ------");
      if(this.textToSpeechService){
        console.log("in stop ----- bot speaking ------, yes was object available");
        this.textToSpeechService.pause(); //pause may only be if using pause with resume, where resume must happen again before stop, verifying...
        ////this.textToSpeechService.stop();
        this.textToSpeechService.updateState({
          isPlaying: false,
          isSpeaking: false,
          isIgnoreUntilNextDialog: true});

        this.textToSpeechService.clearQueue();
      }
      this.isAudioPlaybackStarted$.next(false);
    }
    // do not blindly call textospeech stop
    // else {
    //   if(this.textToSpeechService){
    // //   this.textToSpeechService.stop();
    //   }
    // }


    // if (this.audio) {

    //   this.audio.load();

    //   // this.audio.currentTime = 0; // Reset to the beginning
    //   // this.audio.pause(); // Pause the audio

    //   this.audio = null; // Clear the reference
    //   this.isAudioPlaybackStarted$.next(false);
    // }



    // if(this.waveCircleClassObj){
    //   this.waveCircleClassObj.stop();
    //   this.waveCircleClassObj.undraw();
    // }


    // if(this.connection){
    //   console.log("request deepgram connection close");
    //   this.connection.requestClose();
    //   this.connection.disconnect();
    //   this.connection;
    // }

  //   if(this.audioCaptureService){
  //     console.log("stopping audio apture service");
  //     this.audioCaptureService.cleanup(); //main service STOP recording/listening
  //  }

    if(areaOfApp=="bin"){
      this.totalUserInput = [];
      this.userInput$.next("");
      this.isDeleteUserInputOptionAvailable$.next(false);
      setTimeout(() => this.adjustMainInputHeight(), 100);
    }




  }


  /**
   *
   */
  private scrollToBottom(): void {
    try {
      //setTimeout(() => this.scrollToBottom(), 0);
      setTimeout(() => {
        this.chatContent.nativeElement.scrollTop =
          this.chatContent.nativeElement.scrollHeight;
      }, 0); // Ensure it runs after the DOM updates
    } catch (err) {
      console.error('Scroll to bottom failed:', err);
    }
  }


  getCurrentFormattedTime(): string {
    const now = new Date();
    return now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  }


  getCurrentFormattedDateTime(serverDateTime?: string): string {
    const date = serverDateTime ? new Date(serverDateTime) : new Date();

    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  }


  sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }



  private parseBoolean(value: string | null): boolean {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return false; // Default to false for invalid values
  }

  // Helper function to format elapsed time in seconds
  private formatElapsedTime(milliseconds: number, modMilliseconds: number = 0): string {

    // logic to be able to modify timelapse dynamically +/- by milliseconds
    modMilliseconds = modMilliseconds != 0 ? modMilliseconds + modMilliseconds : modMilliseconds;

    const seconds = milliseconds / 1000; // Convert to seconds

    // Determine singular or plural
    const label = seconds === 1 ? 'Second' : 'Seconds';

    // Format as integer or with two decimal places
    return Number.isInteger(seconds)
      ? `${seconds} ${label}` // Whole number case
      : `${seconds.toFixed(2)} ${label}`; // Decimal case
  }


  private generateRandomString(words: string[]): string {
    const randomIndex = Math.floor(Math.random() * words.length);
    return words[randomIndex];
  }

  private stripHtml(html) {
    return html.replace(/<[^>]*>/g, '');
  }

  private remove_non_ascii(str) {
    // Check if the input string is null or empty. If true, return false.
    if ((str===null) || (str===''))
         return false;
    // Convert the input string to a string if it's not already
    else
      str = str.toString();

    // Use the replace method with a regular expression to remove non-ASCII characters
    // The regular expression /[^\x20-\x7E]/g matches any character that is not in the range of ASCII printable characters (hexadecimal values from 0x20 to 0x7E)
    return str.replace(/[^\x20-\x7E]/g, '');
  }


  // private writeFile() {
  //   if (audioBuffer.length > 0) {
  //     (this.fs.writeFile("output.mp3", (audioBuffer, (err) => {
  //       if (err) {
  //         console.error("Error writing audio file:", err);
  //       } else {
  //         console.log("Audio file saved as output.mp3");
  //       }
  //     });
  //     audioBuffer = Buffer.alloc(0); // Reset buffer after writing
  //   }
  // };


  // generateSpeech(text) {
  //   this.isLoading = true;
  //   this.error = null;
  //   this.audioSource = null;

  //   this.pollyService.streamTextBase64(text)
  //     .subscribe({
  //       next: (base64Audio: string) => {
  //         this.playAudioResponse(base64Audio);
  //         // Create audio source from base64 data
  //         // const audioDataUrl = `data:audio/mp3;base64,${base64Audio}`;
  //         // this.audioSource = this.sanitizer.bypassSecurityTrustUrl(audioDataUrl);
  //         // this.isLoading = false;
  //       },
  //       error: (error: any) => {
  //         this.error = 'Error generating audio: ' + error.message;
  //         this.isLoading = false;
  //       }
  //     });
  // }




  playBase64Audio(base64Array) {
    let index = 0;

    function playNext() {
      if (index >= base64Array.length) {
        return;
      }

      const audio = new Audio('data:audio/wav;base64,' + base64Array[index]);

      audio.onended = () => {
        index++;
        playNext();
      };

      audio.play();
    }

    playNext();
  }


  // async doStreamAudioTest(streamingTextToSpeak) {

  //   let b64Audio = "";
  //   const subaudio = this.getAudioStream(streamingTextToSpeak)
  //   .pipe(
  //     tap((x) =>{
  //       // this.playAudioResponse(b64Audio);
  //       //this.audioStreamService.streamAudio(of(b64Audio));
  //     })
  //   )
  //   .subscribe(data => {
  //     // console.log(data);

  //     if (data?.data) {

  //       //console.log("+++has a data message", data?.data);
  //       const base64Data = data?.data.trim();
  //       const binaryData = atob(base64Data);
  //       b64Audio = base64Data;

  //       this.streamResponseTextChunksAudioArray.push(base64Data);
  //       //this.playBase64Audio(this.streamResponseTextChunksAudioArray);
  //       //this.playAudioResponse(base64Data);
  //       //this.audioStreamService.streamAudio(of(binaryData));

  //       subaudio.unsubscribe();
  //     }
  //   });
  // }


  // /**
  //  *
  //  * @param questionText
  //  * @returns
  //  */
  // getAudioStream(questionText): Observable<any> {

  //   const payload = { question: questionText };
  //   //const headers = new HttpHeaders().set('X-GFH-AI-CHATBOT-CIF', `${this.cif}`);
  //   // const headers = new HttpHeaders().set('X-GFH-AI-CHATBOT-CIF', `999999`);
  //   const headers = new HttpHeaders({
  //     'X-GFH-AI-CHATBOT-CIF': `${this.cif}`,
  //   });

  //   console.log("Here is the stream response that will be spoken", payload);

  //   // return the stream Observable
  //   return this.sseClient.stream(this.apiUrl + '/synthesize',
  //     {
  //       keepAlive: true,
  //       reconnectionDelay: 1_000,
  //       responseType: 'event'
  //     },
  //     { body: payload, headers: headers },
  //     'POST')
  // }



  //...testing aws polly streaming
  private connectToSSE() {
    this.eventSource = new EventSource(this.apiUrl + '/stream');

    let cntIt = 0;

    this.eventSource.onmessage = (event) => {
      let chunk = JSON.parse(event.data);
      console.info(chunk?.text);
      if(chunk?.text == "end_of_stream"){
        console.log("hit end of stream-----------------");
        this.eventSource.close();
      }
      else {
        cntIt++;
        //chunk = event.data;
        this.textBuffer += chunk?.text;
        this.accumulatedText += chunk?.text;

        console.log("+++++++ hitting a chunk,", chunk);
      }

      // // Process text buffer when we have enough content or hit punctuation
      let isProcessOfBuffer = this.shouldProcessBuffer();
      console.info("do we process the buffer or no, ", this.shouldProcessBuffer());
      //if (isProcessOfBuffer) {
        this.processTextBuffer(cntIt);
      //}
    };

    this.eventSource.onerror = (error) => {
      console.error('SSE Error:', error);
      this.eventSource.close();
    };
  }

  private shouldProcessBuffer(): boolean {
    // Process when we hit punctuation or have enough characters
    return this.textBuffer.match(/[.!?]/) !== null || this.textBuffer.length > 10;
  }

  private async processTextBuffer(cntIt) {
    const textToProcess = this.textBuffer;
    this.textBuffer = '';  // Clear buffer

    console.log("text to process: ", textToProcess);

    try {
      const response = await fetch(this.apiUrl + '/synthesize', {
        method: 'POST',
        headers: getApiAuthHeaders({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify({ text: textToProcess, cnt: cntIt })
      }).then((x) => {
        let bodyAudioReader = x.body.getReader();;
        console.log(bodyAudioReader);

        return new ReadableStream({
          start(controller) {
            return pump();
            function pump() {
              return bodyAudioReader.read().then(({ done, value }) => {
                // When no more data needs to be consumed, close the stream
                if (done) {
                  this.playAudioResponse(value);
                  controller.close();
                  return;
                }
                this.playAudioResponse(value);
                // Enqueue the next data chunk into our target stream
                controller.enqueue(value);
                return pump();
              });
            }
          },
        });




      })

    } catch (error) {
      console.error('Error processing audio:', error);
    }
  }

  private async playNextInQueue() {
    if (this.audioQueue.length === 0) {
      this.isPlaying = false;
      this.hasAudioToPlay = false;
      return;
    }

    this.isPlaying = true;
    const audioBuffer = this.audioQueue.shift();
    const source = this.audioContext.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(this.audioContext.destination);

    source.onended = () => {
      this.playNextInQueue();
    };

    source.start();
  }

  public toggleAudio() {
    if (this.isPlaying) {
      this.audioContext.suspend();
      this.isPlaying = false;
    } else {
      this.audioContext.resume();
      this.playNextInQueue();
    }
  }



  // Deepgram Websocket
  private cleanupResources() {
    if (this.audioWorkletNode) {

      if(this.audioWorkletNode?.port){
        this.audioWorkletNode.port.close();
      }

      this.audioWorkletNode.disconnect();
      this.audioWorkletNode = null;
    }
    if (this.microphoneStream) {
      this.microphoneStream.getTracks().forEach((track) => track.stop());
      this.microphoneStream = null;
    }
    if (this.audioContext) {
      this.audioContext.close();
      this.audioContext = null;
    }
  }



  /**
   * Start Transcribinging from Microphone click
   */
  async startDeepgramWSStreaming(isMobileMedia) {
    try {

      // update the icon for the mic to a waiting icon
      this.isWaitingForMicAudioOrSocket$.next(true);
      this.tmp__ui_user_input_placehoder_text = "...";


      this.cleanupResources();

      let retainUserInput: string[] = [];
      if(this.userInput$.value){
        console.log("pushing intiial value");
        retainUserInput.push(this.userInput$.value);
      }

      let cntFinals = 0;
      let previousTranscribeResult = "";
      let utteranceEndResult = "";

      // To Store Audio Recording Create a buffer to store PCM chunks
      this.recordedFileChunks = [];

      // Connecting to Socket
      const socket = await this.deepgramWebSocketService.connect();

      //check permissions
      this.privInfo = this.getPermissions();


      if (!isMobileMedia) {
        // This is with the Audio Context When we are using Desktop like devices

        // Configuration for audio capture
        const audioConstraints = {
          audio: {
            sampleRate: 16000,
            channelCount: 1,
            echoCancellation: true,
            autoGainControl: true,
            noiseSuppression: true
          },
          video: false,
        };

        console.log("is hecking if mic has been allowed.");
        // Create the AudioContext with the correct sample rate
        // this.audioContext = new AudioContext({ sampleRate: 16000, latencyHint: "interactive" });
        this.audioContext =
        new (window.AudioContext || (window as any).webkitAudioContext)({ sampleRate: 16000, latencyHint: "interactive" });

        console.log("Mic check is complete???.");

        // Resume the audio context to avoid browser restrictions
        if (this.audioContext.state === 'suspended') {
          await this.audioContext.resume();
        }
        // Load the worklet processor
        await this.audioContext.audioWorklet.addModule('assets/pcm-worklet-processor.js');

        // Create the worklet node
        this.audioWorkletNode = new AudioWorkletNode(this.audioContext, 'pcm-processor');

        // Connect the worklet node to the audio context
        this.microphoneStream = await navigator.mediaDevices.getUserMedia(audioConstraints);
        const source = this.audioContext.createMediaStreamSource(this.microphoneStream);
        source.connect(this.audioWorkletNode);




        // mic is connected (or is it not connected until the audioContext is selected????)
        console.log("socket will be connected here");
        this.isWaitingForMicAudioOrSocket$.next(false);

        this.isSpeechListening$.next(true);
        this.tmp__ui_user_input_placehoder_text = "Start talking...";

        // Handle PCM data from the worklet processor
        this.audioWorkletNode.port.onmessage = (event) => {
          const pcmData = event.data;

          if (this.isToRecordToFile) {
            // Adding chunks for file
            this.recordedFileChunks.push(new Float32Array(pcmData));
          }

          // Sending audio data to deepgram
          this.deepgramWebSocketService.sendAudioChunk(pcmData);

          //console.info("asdf", new Float32Array(pcmData));



          const dataArray = new Uint8Array(pcmData);

          // Calculate average frequency value
          const average = dataArray.reduce((a, b) => a + b, 0) / 128;
          this.streamBytes$.next(average);
          // console.log(average);



        };


      }
      else {
        // This is for mobile devices and browsers like safari
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({ audio: true })
            .then(stream => {
              try {
                const mediaRecorder = new MediaRecorder(stream);



                // mic is connected (or is it not connected until the audioContext is selected????)
                console.log("mic for socket will be connected here");
                this.isWaitingForMicAudioOrSocket$.next(false);


                mediaRecorder.ondataavailable = (event) => {
                  if (event.data.size > 0) {
                    event.data.arrayBuffer()
                      .then((arrayBuffer) => {
                        if (this.isToRecordToFile) {
                          // Adding chunks for file
                          this.recordedFileChunks.push(arrayBuffer);
                        }
                        // Send the ArrayBuffer to the WebSocket
                        this.deepgramWebSocketService.sendAudioChunk(this.convertToPCM(arrayBuffer));
                      })
                      .catch((error) => {
                        console.error('Error converting Blob to ArrayBuffer:', error);
                      });
                  }
                };

                mediaRecorder.onstart = () => console.log('Recording started');
                mediaRecorder.onerror = (error) => console.error('MediaRecorder error:', error);

                // Start recording (adjust interval as necessary)
                mediaRecorder.start(100);
              } catch (e) {
                console.error('MediaRecorder not supported or failed:', e);
              }
            })
            .catch(error => {
              console.error('Error accessing microphone:', error);
              alert('Microphone access is required to use this feature.');
            });
        } else {
          console.error('get_UserMedia not supported on this browser.');
          alert('Your browser does not support audio recording.');
        }
      }



      // Receive transcript from Deepgram
      socket.onmessage = (event) => {
        const result = JSON.parse(event.data);
        //console.log("onmessage dg", result, result.speech_final);

        if(result?.type == "Results") {
          previousTranscribeResult = result?.channel?.alternatives[0]?.transcript;
          if(previousTranscribeResult == result?.channel?.alternatives[0]?.transcript) {
            //console.log("^^^^^^^^^^^^^ words/transcribe matching from exact previous");
            this.userInput$.next(retainUserInput.join(" "));
          }

          //update the effect on the send arrow, only if there is a value in the text  field
          if(this.countWords(previousTranscribeResult) > 3){
            //console.log("has value and setting isSendReady to true...")
            this.isSendReady$.next(true);
          }



          if (result?.speech_final || result?.is_final) {

            if(result.channel?.alternatives[0]?.transcript.length > 0) {
              cntFinals++;

              // if(retainUserInput.length >= cntFinals && retainUserInput.lastIndexOf(result.channel?.alternatives[0]?.transcript)){
              //   let retainIndexedRemoved = retainUserInput.pop();
              //   console.log("**removing an index", retainIndexedRemoved);
              // }
              // else {
                retainUserInput.push(result.channel?.alternatives[0]?.transcript); //what is my, what is my portfolio balance
                this.userInput$.next(retainUserInput.join(" ") + " "); // what is my, what is my, what is my portfolio balance,
              // }
            }
          }

          if(result?.channel?.alternatives[0]?.transcript && result?.channel?.alternatives[0]?.transcript.length > 0){
            this.userInput$.next(retainUserInput.join(" ") + result?.channel?.alternatives[0]?.transcript);
          }
        }
        else if(result?.type == "UtteranceEnd"){
          utteranceEndResult = "";
        }

        // check if any user input available after all of the above if so mark as true that text exists
        if(this.userInput$.value){
          this.isDeleteUserInputOptionAvailable$.next(true);
        }

        this.adjustMainInputHeight();
      };

      this.isRecording = true;
      this.isSpeechListening$.next(true);
      this.tmp__ui_user_input_placehoder_text = "Start talking...";

    }
    catch (error) {
      this.isWaitingForMicAudioOrSocket$.next(false);
      this.isSpeechListening$.next(false);
      console.error('Error starting audio stream:', error);

      // TODO: This happens when MIC is not available at all (i.e.: No MIC)
      //       Handle this error by causing microphone to be disabled with a different icon, or give message



    }


    //
    // start the timeout concept
    // NB: if the stop button is pressed any where(stopAudio()) it will cancell this timeout by its variable name
    //
    // TODO: Make this a global customer configuration option
    //
    this.autoSendFromTranscribeTimeout = setTimeout(() => {

      //explicityly stop the mic (or main transcribe mic concept)
      this.stopDeepgramWSStreaming();


      // this.audioCaptureService.cleanup(); //main service STOP recording/listening
      this.isSpeechListening$.next(false);

      // reset temp placeholder
      this.tmp__ui_user_input_placehoder_text = this.final__ui_user_input_placehoder_text;

      // if the text in the user input field is same as when mic was turned on then reset
      // otherwise we need to keep the text because the user will now send the message
      if(this.final__speak_now_text == this.userInput$.value){
        this.userInput$.next(""); // reset this to show the placeholder only
      }
      else {
        // Auto send based on timer completion (commented out per Reem and team call on 11/21/2024)
        //this.sendMessageGetStream(null);
      }

      // keep full stop to clean up ay potential bogus audio or conflicts
      this.stopAudio(null, null);

      console.log("mic closed by timer at x seconds...since start");
    }, this.final__audio_intake_timeout_ms);

  }



  /**
   *
   */
  stopDeepgramWSStreaming() {

    //this.stopAudio(null, null);

    if (this.audioWorkletNode) this.audioWorkletNode.disconnect();
    if (this.microphoneStream) {
      this.microphoneStream.getTracks().forEach((track) => track.stop());
    }
    this.deepgramWebSocketService.disconnect();
    this.isRecording = false;
    this.isSpeechListening$.next(false);

    // This will stop recording to file and allow it to save
    if (this.isToRecordToFile) {
      this.stopAndSaveFileRecording();
    }
  }


  convertToPCM(audioData) {
    const buffer = new ArrayBuffer(audioData.length * 2); // 16-bit PCM
    const view = new DataView(buffer);

    for (let i = 0; i < audioData.length; i++) {
      let sample = Math.max(-1, Math.min(1, audioData[i])); // Clamp between -1 and 1
      sample = sample < 0 ? sample * 0x8000 : sample * 0x7fff; // Convert to 16-bit PCM
      view.setInt16(i * 2, sample, true); // Little-endian
    }

    return buffer;
  }


  /**
   *
   * @param e
   * @returns
   */
  async sendMessageGetStream(e) {
    console.log("showing value", e);
    if (!this.userInput$.getValue().trim() || this.userInput$.getValue() == this.final__speak_now_text) return;
    if (this.sessionAuthService.isSessionExpired()) {
      this.isChatbotAccessible$.next(false);
      this.showAuthError$.next(true);
      return;
    }

    this.isServerResponding$.next(true);

    // stop any transcribing or talking to submit
    this.stopAudio(null, "stop_bot_speaking");

    // reset the state to remove the TTS ignore after a stop
    if(this.textToSpeechService) {
      this.textToSpeechService.updateState({
        isPlaying: false,
        isSpeaking: false,
        isIgnoreUntilNextDialog: false});
    }

    const question = this.offensiveFilter.clean(this.userInput$.getValue().trim());
    this.contextualSuggestions = [];

    var userMessage = new ChatMessage(this.chatMessageId,
      MessageSenderTypeEnum.user,
      question,
      MessageTypeEnum.TEXT.toString(),
      this.getCurrentFormattedDateTime(),
      '',
      ''
    );

    this.addMessage(userMessage);

    // Commented this Based on Request from Osama 18/11
    /*var initialBotResponse = "";
    const greetings = ["hi", "hello", "hey"];
    const thanks = ["thank you", "thanks", "thx", "ty"];
    const userQuestionLower = question.toLowerCase();
    if (greetings.some((word) => userQuestionLower.includes(word))) {
      initialBotResponse = this.greetingResponses[Math.floor(Math.random() * this.greetingResponses.length)];
    } else if (thanks.some((word) => userQuestionLower.includes(word))) {
      initialBotResponse = this.thankYouResponses[Math.floor(Math.random() * this.thankYouResponses.length)];
    } else {
      initialBotResponse = this.initialBotResponseWords[Math.floor(Math.random() * this.initialBotResponseWords.length)];
    }*/


    let testtext = "";
    let responsePartialStream = "";
    let chatResponse: ChatMessage;
    //let initialBotResponse = this.generateRandomString(this.initialBotResponseWords);
    // add blazing fast bot response
    chatResponse = new ChatMessage(this.chatMessageId,
      MessageSenderTypeEnum.bot,
      '',
      MessageTypeEnum.TEXT.toString(),
      this.getCurrentFormattedDateTime(),
      '',
      ''
    );

    this.addMessage(chatResponse);


    this.userInput$.next('');
    this.userInputNgModel = '';
    setTimeout(() => this.adjustMainInputHeight(), 100);

    this.isDeleteUserInputOptionAvailable$.next(false);
    this.totalUserInput = [];

    this.isTyping = true; // Show typing indicator

    setTimeout(() => this.scrollToBottom(), 0);

    let cntStreamTokens = 0;

    let requestStartTime = performance.now();


    const sub = this.getChatResponseStream(question)
      .pipe(
        finalize(() => {
            // //speak entire text here
            // testtext = this.remove_non_ascii(testtext);
            // this.getVoiceResponsePerClient(testtext).subscribe({
            //   next: (response) => {
            //     console.log("audio response parent", response);
            //     this.playAudioResponse(response.audio_response); // Play audio after receiving it
            //   }
            // });
            console.log("-----------------final success?..text...");


            // //are we making a chart or not
            // if (chartFromTextParser.hasMultipleInvestments(chatResponse.text)) {
            //   const investments = chartFromTextParser.parseInvestments(chatResponse.text);
            //   const chartConfig = chartFromTextParser.generateEChartsConfig(investments);

            //   console.log("=============>");

            //   let eChartOption = chartConfig;

            //   this.echartOptions.push(
            //     {key: chatResponse.id, value: eChartOption, optionality: {height: 400}}
            //   )

            //   // Initialize eCharts here with chartConfig
            //   // console.log("here was that test string", chatResponse.text); //htmlStringTest
            //   // console.log("investments", investments);
            //   // console.info("yes, we have the formatting of a chart ready", chatResponse.text);
            // }

            // this should not be else..if because it could have both markdown and markdown table. Maybe adjust if we get JSON
            const normalizedStreamText = this.prepareStreamTextForDisplay(testtext);
            chatResponse.text = this.renderChatMessageHtml(testtext);
            if (chartFromTextParser.hasMarkdownTable(normalizedStreamText)) {
              console.log("finalizing call to produce table...");

              let extractedMDTable = this.extractMarkdownTable(normalizedStreamText);

              const chartableTable = this.findChartableTable(extractedMDTable, chatResponse.text);
              if (chartableTable) {
                const chartConfig = chartFromTextParser.generateEChartsConfig(chartableTable);
                let eChartOption = chartConfig;

                if(eChartOption){
                  this.echartOptions.push(
                    {key: chatResponse.id, value: eChartOption, optionality: {height: 400}}
                  )
                }
              }
            }


            //this.isAudioPlaybackStarted$.next(false); //stop audio on finalize. This could be just for
            this.isServerResponding$.next(false);
            this.contextualSuggestions = this.generateContextualSuggestions(question, testtext);
        }),
        tap((response) => {
        }),
        catchError((error) => {
          console.error("enountered an error", error);
          debugLog.error('chat/stream', 'Chat request failed (catchError)', {
            ...debugLog.describeHttpError(error),
            endpoint: this.apiUrl + '/test_ask_question2',
            hasCif: !!this.cif
          });
          const elapsedTime = performance.now() - requestStartTime; // Calculate elapsed time
          const formattedElapsedTime = this.formatElapsedTime(elapsedTime);
          this.isTyping = false; // Hide typing indicator

          var chatErrResponse = new ChatMessage(this.chatMessageId,
            MessageSenderTypeEnum.bot.toString(),
            'Something went wrong. Please try again. An issue has been logged with our AI chat team.',
            MessageTypeEnum.TEXT.toString(),
            this.getCurrentFormattedDateTime(),
            '',
            formattedElapsedTime
          );
          this.addMessage(chatErrResponse);
          return of(error);
        })
      )
      .subscribe(
        async (event) => {
          if (event.type === 'error') {
            const errorEvent = event as ErrorEvent;
            console.error(":Error at Retrieving chat message, ", errorEvent?.error, errorEvent?.message, errorEvent);
            debugLog.error('chat/stream', 'SSE stream returned an error event', {
              ...debugLog.describeHttpError((errorEvent as any)?.error ?? errorEvent),
              message: errorEvent?.message,
              endpoint: this.apiUrl + '/test_ask_question2'
            });
            sub.unsubscribe();
            this.isStopStream$.next(true);

            const elapsedTime = performance.now() - requestStartTime; // Calculate elapsed time
            const formattedElapsedTime = this.formatElapsedTime(elapsedTime);
            this.isTyping = false; // Hide typing indicator

            var chatErrResponse = new ChatMessage(this.chatMessageId,
              MessageSenderTypeEnum.bot.toString(),
              'Something went wrong with the request. Please try again or contact your relationship manager.',
              MessageTypeEnum.TEXT.toString(),
              this.getCurrentFormattedDateTime(),
              '',
              formattedElapsedTime
            );
            this.addMessage(chatErrResponse);


          } else {
            const messageEvent = event as MessageEvent;
            // console.log("here is the EVENT only", event);
            //console.log("here is the messageEvent", messageEvent);
            //console.log(messageEvent);
            // console.info(`SSE request with event N/A" and type "${messageEvent?.type}" and data "${messageEvent?.data}"`);

            // NB: if this data point equals that of our last final/finally message in the api then unsubscribe
            //     and close the stream
            // ??? should this be beloe the other condition for end steram response here below
            if(messageEvent?.data == "end_of_stream_response"){
              sub.unsubscribe();
              //, or,
              this.isStopStream$.next(true);
              // this.isStopStream$.next();
              // this.isStopStream$.complete();
            }

            let response = messageEvent;

            if( response.data !== "end_of_stream_response") {
              if( cntStreamTokens > 0 ) {

                const currentMessages = this.messagesSubject.getValue();
                let updatedMessages = this.updateMessage(currentMessages, chatResponse, MessageSenderTypeEnum.bot.toString());
                this.messagesSubject.next([...updatedMessages]);


                // if getting the audio chunk from the fastapi endpoint
                let audioChunk = "";
                if(response.data.startsWith("^audio^")){
                  audioChunk = response.data.replace(/\^audio\^/g, "");

                  // check the state and if ignoring then do not play returned audio stream though it comes in the stream response still
                  if(!this.textToSpeechService?.getState()?.isIgnoreUntilNextDialog) {
                    //this.playAudioResponse(audioChunk);
                    this.textToSpeechService.playPollyAudio(audioChunk);

                    // set observable to true for playback is starting,
                    // if needing to STOP just audio then use textToSpeechService STATE attribute subscribe()
                    this.isAudioPlaybackStarted$.next(true);
                  }
                  else {
                    this.isAudioPlaybackStarted$.next(false);
                  }


                }
                else {


                  const data_from_sse = response.data.replace(/\^\^/g, " ") ; //response.data.replace(/\u2002/g, ' ');

                  //console.log(data_from_sse)
                  testtext += data_from_sse;
                  //console.log(testtext);

                  responsePartialStream += data_from_sse;



                  // call the TTOS option if config/admin setting condition is met
                  // dgConnectionSpeak.sendText(data_from_sse);
                  //if((cntStreamTokens % 10===0) ||
                  if(this.listOfSpechOutputPunctuations.some(char => responsePartialStream.includes(char)))
                  {

                    this.streamResponseTextChunksArray.push(responsePartialStream);

                    //console.info("SAY THIS....", responsePartialStream);
                  }





                  // --------------------
                  // TODO: test this logic and see the console.log to see if an html table can be continuaously generated ( max 1hr dev)
                  //       if not then we must set up a DIV in the HTML component and do similar to the CHART where the structure is assigned
                  //      for the table and the markdown table to object array is used in the streaming recovery loop so that the Headers and
                  //      rows simply build from the array but there is no need to produce secondary HTML text only update the array used in an
                  //      HTML table template
                  // this should not be else..if because it could have both markdown and markdown table. Maybe adjust if we get JSON
                  // if (chartFromTextParser.hasMarkdownTable(chatResponse.text)) {
                  //   console.log("finalizing call to produce table...");

                  //   let extractedMDTable = this.extractMarkdownTable(chatResponse.text);

                  //   // console.log(extractedMDTable);

                  //   let extractedMDTableCleanedUp = extractedMDTable[0].replace(/<br\/>/gi, "\n"); //removes any breaks from the table

                  //   console.log(extractedMDTableCleanedUp);

                  //   // replace the cleaned up markdown with HTML in the response
                  //   // const newStr = chatResponse.text.replace(chartFromTextParser.TABLE_DETECTION_PATTERN,
                  //   //   markdown.markdown(extractedMDTableCleanedUp));
                  //   // chatResponse.text = newStr;
                  // }
                  // --------------------


                  // check if the object in the messages was found otherwise don't add anything or it will ABEND
                  if(chatResponse){
                    //console.log("found message to update", chatResponse);
                    chatResponse.text = this.renderChatMessageHtml(testtext);
                  }



                }

              }
              else {
                console.log("da response", response);
                const elapsedTime = performance.now() - requestStartTime; // Calculate elapsed time
                const formattedElapsedTime = this.formatElapsedTime(elapsedTime, 0);

                this.isTyping = false; // Hide typing indicator

                testtext = response.data;
                responsePartialStream = response.data;

                console.log("-------------------hitting this first still");

                const currentMessages = this.messagesSubject.getValue();
                let updatedMessages = this.updateMessage(currentMessages, chatResponse, MessageSenderTypeEnum.bot.toString());
                this.messagesSubject.next([...updatedMessages]);

                // check if the object in the messages was found otherwise don't add anything or it will ABEND
                if(chatResponse){
                  console.log("found initial message to update", chatResponse);
                  chatResponse.elapsedTime = formattedElapsedTime;
                }

              }
            }
            // increment the token count
            cntStreamTokens++;

            // console.log("PRINT OUT ARRAY", this.streamResponseTextChunksArray.join(" "));
            // console.log("PRINT OUT ARRAY LENG", this.streamResponseTextChunksArray.length);

            setTimeout(() => this.scrollToBottom(), 0);

          }
        },
        (error)=> {
          this.isStopStream$.next(true);
        },
        () => {

          console.log("#### success area");

          //scroll to the bottom
          setTimeout(() => this.scrollToBottom(), 0);
          //clean up
          this.userInput$.next('');
          this.isDeleteUserInputOptionAvailable$.next(false);
        }
      );
  }

  sendContextualSuggestion(question: string): void {
    this.contextualSuggestions = [];
    this.userInput$.next(question);
    this.sendMessageGetStream(question);
  }

  private generateContextualSuggestions(question: string, answer: string): string[] {
    const normalizedQuestion = (question || '').toLowerCase();
    const normalizedContext = `${question || ''} ${answer || ''}`.toLowerCase();

    const matchedRules: typeof this.contextualSuggestionRules = [];
    const unmatchedRules: typeof this.contextualSuggestionRules = [];

    for (const rule of this.contextualSuggestionRules) {
      if (rule.keywords.some((keyword) => normalizedContext.includes(keyword))) {
        matchedRules.push(rule);
      } else {
        unmatchedRules.push(rule);
      }
    }

    const result: string[] = [];

    for (const rule of matchedRules) {
      const candidate = rule.suggestions.find(
        (s) => s.toLowerCase() !== normalizedQuestion && !result.includes(s)
      );
      if (candidate) result.push(candidate);
      if (result.length === 3) break;
    }

    for (const rule of unmatchedRules) {
      if (result.length >= 3) break;
      const candidate = rule.suggestions.find(
        (s) => s.toLowerCase() !== normalizedQuestion && !result.includes(s)
      );
      if (candidate) result.push(candidate);
    }

    if (result.length === 0) {
      return [
        'What is my total portfolio size?',
        'What are the latest Wakala rates?',
        'What is my available cash account balance?',
      ];
    }

    return result.slice(0, 3);
  }


  // Stop recording and save the file
  stopAndSaveFileRecording = () => {
  // Combine all PCM chunks
  const combinedBuffer = this.flattenChunks(this.recordedFileChunks);

  // Convert PCM to WAV
  const wavBlob = this.createWavFile(combinedBuffer, 16000);

  // Create a downloadable link
  const url = URL.createObjectURL(wavBlob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = 'recording.wav';
  document.body.appendChild(a);
  a.click();

  // Clean up
  URL.revokeObjectURL(url);
  this.recordedFileChunks = [];
};

  // Utility function to flatten recorded chunks
  flattenChunks(chunks: Float32Array[]): Float32Array {
    const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
    const result = new Float32Array(totalLength);

    let offset = 0;
    chunks.forEach((chunk) => {
      result.set(chunk, offset);
      offset += chunk.length;
    });

    return result;
  }

  // Utility function to encode WAV
  encodeWAV(samples, sampleRate) {
    const buffer = new ArrayBuffer(44 + samples.length * 2);
    const view = new DataView(buffer);

    // Write WAV header
    this.writeString(view, 0, 'RIFF');
    view.setUint32(4, 36 + samples.length * 2, true); // File size
    this.writeString(view, 8, 'WAVE');
    this.writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true); // Subchunk1Size
    view.setUint16(20, 1, true); // Audio format (1 = PCM)
    view.setUint16(22, 1, true); // Number of channels
    view.setUint32(24, sampleRate, true); // Sample rate
    view.setUint32(28, sampleRate * 2, true); // Byte rate
    view.setUint16(32, 2, true); // Block align
    view.setUint16(34, 16, true); // Bits per sample
    this.writeString(view, 36, 'data');
    view.setUint32(40, samples.length * 2, true); // Data chunk size

    // Write PCM samples
    let offset = 44; // Use `let` instead of `const`
    for (let i = 0; i < samples.length; i++, offset += 2) {
      const s = Math.max(-1, Math.min(1, samples[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
    }

    return buffer;
  }

  createWavFile(audioBuffer, sampleRate) {
    const wavBuffer = this.encodeWAV(audioBuffer, sampleRate);
    return new Blob([wavBuffer], { type: 'audio/wav' }); // Fixed line
  }




  // Utility function to write strings to DataView
  writeString(view, offset, string) {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  }

  onChatInputFocus(): void {
    this.resetPageScrollForKeyboard();
    this.visualViewportUpdate?.();

    requestAnimationFrame(() => {
      this.resetPageScrollForKeyboard();
      this.visualViewportUpdate?.();
    });

    [50, 150, 300].forEach((delay) => {
      setTimeout(() => {
        this.resetPageScrollForKeyboard();
        this.visualViewportUpdate?.();
      }, delay);
    });

    if (this.isMobileChatViewport()) {
      return;
    }

    requestAnimationFrame(() => {
      const el = this.mainTextAreaInput?.nativeElement as HTMLElement | undefined;
      el?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  adjustMainInputHeight(): void {
    const textarea = this.mainTextAreaInput.nativeElement;
    textarea.style.height = 'auto'; // Reset the height to recalculate
    textarea.style.height = `${textarea.scrollHeight}px`; // Adjust based on content
  }

  handleKeydownUserInput(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Prevent newline
      this.sendMessageGetStream(event); // Call your message sending logic
    }
  }


  // count words in a string
  countWords(str) {
    var matches = str.match(/[\w\d\’\'-]+/gi);
    return matches ? matches.length : 0;
  }


  getEChartOptionsByResponseId(id): EChartsOption {
    if(this.echartOptions.find(e => e.key === id))
      return this.echartOptions.find(e => e.key === id).value;
    else
      return null;
  }

  //, optionality: {height: 400}
  getEChartInitOptionsByResponseId(id): any {
    if(this.echartOptions.find(e => e.key === id))
      return this.echartOptions.find(e => e.key === id).optionality;
    else
      return {renderer: 'svg', width: 0, height: 0,};
  }

  markdownTableToHTML(markdown) {
    const lines = markdown.trim().split('\n');
    const header = lines[0].split('|').slice(1, -1).map(x => x.trim());
    const rows = lines.slice(2).map(line => {
      return line.split('|').slice(1, -1).map(x => x.trim());
    });

    let html = '<table>\n';
    html += '  <thead>\n';
    html += '    <tr>\n';
    header.forEach(h => html += `      <th>${h}</th>\n`);
    html += '    </tr>\n';
    html += '  </thead>\n';
    html += '  <tbody>\n';
    rows.forEach(row => {
      html += '    <tr>\n';
      row.forEach(cell => html += `      <td>${cell}</td>\n`);
      html += '    </tr>\n';
    });
    html += '  </tbody>\n';
    html += '</table>';

    return html;
  }

  /**
   * SSE streams newlines as <br/>; markdown pipe tables need real line breaks.
   */
  private prepareStreamTextForDisplay(raw: string): string {
    if (!raw) {
      return '';
    }
    const normalized = raw
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/&lt;br\s*\/?&gt;/gi, '\n')
      .replace(/\^\^/g, ' ');
    return this.normalizeMarkdownTableBlocks(normalized);
  }

  /**
   * Keeps section titles and blank lines from splitting a pipe table into header-only + body chunks.
   */
  private normalizeMarkdownTableBlocks(text: string): string {
    const lines = text.split('\n');
    const out: string[] = [];
    let inTable = false;
    let pastSeparator = false;
    const deferred: string[] = [];

    const flushDeferred = () => {
      deferred.forEach((line) => out.push(line));
      deferred.length = 0;
    };

    for (const line of lines) {
      const trimmed = line.trim();
      const isPipeRow = trimmed.startsWith('|') && trimmed.endsWith('|');
      const isSeparator = /^\|[\s\-:|]+\|$/.test(trimmed);

      if (!inTable) {
        if (isPipeRow) {
          inTable = true;
          pastSeparator = false;
          flushDeferred();
          out.push(line);
          continue;
        }
        out.push(line);
        continue;
      }

      if (isSeparator) {
        pastSeparator = true;
        out.push(line);
        continue;
      }

      if (isPipeRow) {
        flushDeferred();
        pastSeparator = false;
        out.push(line);
        continue;
      }

      if (!trimmed) {
        if (!pastSeparator) {
          out.push(line);
        }
        continue;
      }

      if (pastSeparator) {
        deferred.push(line);
        continue;
      }

      inTable = false;
      pastSeparator = false;
      flushDeferred();
      out.push(line);
    }

    flushDeferred();
    return out.join('\n');
  }

  /**
   * Same table pipeline as finalize/history: custom markdown (table-scroll-wrap) + Marked for prose.
   * Supports multiple tables per message (e.g. BHD/USD + AED Wakala rate blocks).
   */
  private renderChatMessageHtml(raw: string): string {
    const normalized = this.prepareStreamTextForDisplay(raw);
    if (!chartFromTextParser.hasMarkdownTable(normalized)) {
      return Marked.parse(this.formatMonetaryAmountsInProse(normalized));
    }

    const pattern = chartFromTextParser.TABLE_DETECTION_PATTERN;
    const re = new RegExp(pattern.source, pattern.flags);
    const matches = Array.from(normalized.matchAll(re));
    if (!matches.length) {
      return Marked.parse(normalized);
    }

    let output = '';
    let lastIndex = 0;
    for (const m of matches) {
      const start = m.index ?? 0;
      const before = normalized.slice(lastIndex, start);
      if (before.trim()) {
        output += Marked.parse(this.formatMonetaryAmountsInProse(before));
      }
      const tableMd = this.formatTableAmountCells(
        m[0].replace(/<br\s*\/?>/gi, '\n')
      );
      output += markdown.markdown(tableMd);
      lastIndex = start + m[0].length;
    }

    const tail = normalized.slice(lastIndex);
    if (tail.trim()) {
      output += Marked.parse(this.formatMonetaryAmountsInProse(tail));
    }
    return output;
  }

  private formatAmountCellContent(cell: string, stripCurrencyPrefix = false): string {
    const trimmed = (cell || '').trim();
    if (!trimmed || trimmed.includes('%')) {
      return cell;
    }

    const currencyMatch = trimmed.match(/^([A-Z]{3})\s+(.+)$/);
    if (currencyMatch) {
      return stripCurrencyPrefix ? currencyMatch[2].trim() : trimmed;
    }

    return trimmed;
  }

  private formatTableAmountCells(tableMd: string): string {
    const lines = tableMd.split('\n').filter((line) => line.trim());
    if (lines.length < 3) {
      return tableMd;
    }

    const headerCells = lines[0]
      .split('|')
      .map((cell) => cell.trim())
      .filter(Boolean);
    const amountIdx = headerCells.findIndex((header) =>
      /^(amount|amount\s*\([^)]+\)|balance|value)$/i.test(header)
    );
    if (amountIdx < 0) {
      return tableMd;
    }

    const hasCurrencyColumn = headerCells.some((header) => /^currency$/i.test(header));

    const formattedLines = lines.map((line, index) => {
      if (index < 2 || !line.trim().startsWith('|')) {
        return line;
      }

      const parts = line.split('|');
      const rowCells = parts.slice(1, -1).map((cell) => cell.trim());
      if (rowCells.length <= amountIdx) {
        return line;
      }

      rowCells[amountIdx] = this.formatAmountCellContent(rowCells[amountIdx], hasCurrencyColumn);
      return `| ${rowCells.join(' | ')} |`;
    });

    return formattedLines.join('\n');
  }

  private formatMonetaryAmountsInProse(text: string): string {
    return text;
  }

  extractMarkdownTable(markdown: string): string[] {
    const tablePattern = chartFromTextParser.TABLE_DETECTION_PATTERN;
    return markdown.match(tablePattern) || [];
  }

  private tableHeaderCells(markdownTable: string): string[] {
    const headerLine = (markdownTable || '')
      .split('\n')
      .find((line) => line.trim().startsWith('|')) || '';

    return headerLine
      .split('|')
      .map((cell) => cell.trim().toLowerCase())
      .filter(Boolean);
  }

  private isCatalogOpportunitiesTable(headers: string[]): boolean {
    const hasProjectColumn =
      headers.includes('project name') ||
      (headers.includes('project') && !headers.includes('investment'));

    const hasCatalogMetrics =
      headers.some((h) => h.includes('expected roi') || h === 'roi') ||
      headers.some((h) => h.includes('cash-on-cash') || h.includes('cash on cash')) ||
      headers.includes('investment tenor') ||
      (headers.includes('tenor') &&
        !headers.includes('remaining tenor') &&
        !headers.includes('term'));

    return hasProjectColumn && hasCatalogMetrics;
  }

  private isPersonalPortfolioChartTable(markdownTable: string, fullText: string = ''): boolean {
    const headers = this.tableHeaderCells(markdownTable);

    if (
      this.isWakalaRatesTable(markdownTable, fullText) ||
      this.isNavOpportunitiesTable(markdownTable, fullText) ||
      this.isCatalogOpportunitiesTable(headers)
    ) {
      return false;
    }

    if (headers.includes('date') && headers.includes('amount')) {
      return false;
    }

    if (
      headers.includes('sector') &&
      headers.some((h) => h.includes('% of portfolio') || h.includes('amount'))
    ) {
      return true;
    }

    if (headers.includes('component') && headers.some((h) => h.includes('amount'))) {
      return true;
    }

    if (
      headers.includes('investment') &&
      headers.some((h) => h === 'amount' || h.includes('amount'))
    ) {
      return true;
    }

    if (
      headers.some((h) => h.includes('account')) &&
      headers.some((h) => h.includes('balance') || h === 'amount' || h.includes('amount'))
    ) {
      return true;
    }

    if (
      headers.some((h) => h.includes('wakala')) &&
      headers.some((h) => h.includes('balance') || h === 'amount' || h.includes('amount'))
    ) {
      return true;
    }

    return false;
  }

  private findChartableTable(tables: string[], renderedHtml: string = ''): string | null {
    for (const rawTable of tables) {
      const table = rawTable.replace(/<br\/>/gi, '\n');
      if (this.isPersonalPortfolioChartTable(table, renderedHtml)) {
        return table;
      }
    }
    return null;
  }

  private shouldRenderChartForTables(tables: string[], renderedHtml: string): boolean {
    return this.findChartableTable(tables, renderedHtml) !== null;
  }

  private isNavOpportunitiesTable(markdownTable: string, fullText: string = ''): boolean {
    const headerLine = (markdownTable || '')
      .split('\n')
      .find(line => line.trim().startsWith('|')) || '';

    const headers = headerLine
      .split('|')
      .map(cell => cell.trim().toLowerCase())
      .filter(Boolean);

    const hasProjectNavHeaders =
      headers.includes('project') &&
      headers.some(h => h === 'nav per share' || h === 'navpershare') &&
      headers.includes('currency');

    // Header-based detection to reliably suppress charts for NAV opportunities tables,
    // even when the intro/section text changes.
    return hasProjectNavHeaders;
  }

  private isWakalaRatesTable(markdownTable: string, fullText: string = ''): boolean {
    const headerLine = (markdownTable || '')
      .split('\n')
      .find(line => line.trim().startsWith('|')) || '';

    const headers = headerLine
      .split('|')
      .map(cell => cell.trim().toLowerCase())
      .filter(Boolean);

    const hasTenorAndRate = headers.includes('tenor') && headers.some(h => h.startsWith('rate'));
    const hasWakalaContext = (fullText || '').toLowerCase().includes('wakala');

    return hasTenorAndRate && hasWakalaContext;
  }

  parseMarkdownTable(markdown: string, toType: string, isHeaderToNamevalue: boolean = true): string[][] {
    const lines = markdown.trim().split("\n");
    const header = lines[0].split("|").map(s => s.trim()).filter(s => s !== "");

    // if toType = 'pie' then set first two cols as name and value
    if(isHeaderToNamevalue){
      header[0] = "name";
      header[1] = "value";
      console.log(header);
    }

    const rows = lines.slice(3).map(line => {
      return line.split("|").map(s => s.trim()).filter(s => s !== "");
    });
    return [header, ...rows];
  }

  tableToObject(table: string[][]): any[] {
    const [header, ...rows] = table;
    return rows.map(row => {
      const obj: any = {};
      header.forEach((key, i) => obj[key] = (row[i].length ? row[i] : "--"));
      return obj;
    });
  }


  /**
   * Parses the MD table to an object array
   * @param markdownTable
   * @param toType
   * @returns
   */
  parseMarkdownTableToObjArray(markdownTable: string, toType: any): ParsedTableRow[] {
    // Split into lines and filter out empty lines
    const lines = markdownTable.trim().split('\n').filter(line => line.trim());

    if (lines.length < 3) {
        throw new Error('Invalid markdown table: Must contain header, separator, and at least one data row');
    }



    // Extract and process headers
    const headers = lines[0]
        .trim()
        .split('|')
        .filter(cell => cell.trim())
        .map(header => header.trim());


    // Check if only one column from Markdown, etc.
    if(headers.length <= 1) {
      return null;
    }

    // //NB: looked to use this logic to potentiall get which column has a % but this was no
    // //    longer necessary in testing
    // // NB: if not found the % then value will be -1
    // const linesOut = lines.slice(2).map(line => {

    //   const index = lines.findIndex(line => line.includes("%"));
    //   console.info(index);

    //   console.info(line.trim().split('|').filter(cell => cell !== '').map(cell => cell.trim()));
    //   return line.trim().split('|').filter(cell => cell !== '').map(cell => cell.trim());
    // });

    // console.info("line out", linesOut);



    // if toType = 'pie' then set first two cols as name and value
    headers[0] = "name";
    headers[1] = "value";
    console.log(headers);

    // Validate separator line
    const separatorLine = lines[1];
    if (!separatorLine.match(/^\|?([\s-:|]+\|)+[\s-:|]+\|?$/)) {
        throw new Error('Invalid markdown table: Separator line malformed');
    }

    // Process data rows
    return lines.slice(2).map(line => {
        const values = line
            .trim()
            .split('|')
            .filter(cell => cell !== '')
            .map(cell => cell.trim());

        // Create object mapping headers to values
        return headers.reduce((obj, header, index) => {
            obj[header] = values[index] || '';
            return obj;
        }, {} as ParsedTableRow);
    });
  }


  /**
   * Converts a string to a number, and handles removing basic info such as
   * commas from the value if originally a string itself,
   * and could be used with numer check logic such as ,
   * typeof str !== "number"
   * @param str
   * @param isReplaceCommas
   * @returns
   */
  convertStringToNumber(str, isReplaceCommas = true){

    if(isReplaceCommas)
      if(typeof str !== "number")
        str = str.replace(/,/g, "");

    if(!isNaN(str)){
      return Number(str)
    }
    else {
      return str;
    }
  }

  report(state: any) {
    console.log('Permission: ', state);
  }

  handlePermission() {
    // @ts-ignore
    // navigator.permissions.query({name: 'microphone'})
    // .then((permissionObj) => {
    //   console.log(permissionObj.state);
    // })
    // .catch((error) => {
    //   console.log('Got error :', error);
    // })

    // NB: must try/catch per permissions/query for MDN Web Docs because some browsers may not have query name type for microphone, etc.
    try{
      // @ts-ignore
      navigator.permissions.query({name:"microphone"}).then((result: any) => {
        console.log("main state", result);
        if (result.state == 'granted') {
          this.report(result.state);
          //geoBtn.style.display = 'none';
        } else if (result.state == 'prompt') {
          this.report(result.state);
          //navigator.geolocation.getCurrentPosition(revealPosition,positionDenied,geoSettings);
        } else if (result.state == 'denied') {
          this.report(result.state);
          //geoBtn.style.display = 'inline';
        }
      });
    }
    catch(e) {
      console.log("Error with checking permissions for microphone (browser issue)", e);
    }
  }

  async navigateToAgent(): Promise<void> {
    this.stopAudio(null, "stop_bot_speaking");

    try {
      await this.primeVoiceAgentForUserGesture();
    } catch (error) {
      debugLog.warn('voice/prime', 'Voice agent priming failed', {
        error: error instanceof Error ? `${error.name}: ${error.message}` : String(error),
        hasKmMeta: !!localStorage.getItem('km_meta'),
        hasAccessToken: !!this.sessionAuthService.getAccessToken(),
        hasCif: !!this.cif,
        hasGetUserMedia: !!navigator.mediaDevices?.getUserMedia,
      });
    }

    this.isConversationalAgent$.next(true);
  }

  private async primeVoiceAgentForUserGesture(): Promise<void> {
    const kmMeta = localStorage.getItem('km_meta');
    if (!kmMeta) {
      throw new Error('Voice agent unavailable: missing realtime credentials');
    }

    if (!navigator.mediaDevices?.getUserMedia) {
      throw new Error('Microphone access is not supported in this browser');
    }

    const existingStream = this.microphoneService.getStream();
    if (!existingStream || existingStream.getAudioTracks().every((track) => track.readyState === 'ended')) {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
        video: false,
      });
      this.microphoneService.setStream(stream);
    }

    const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtx) {
      return;
    }

    const ctx = new AudioCtx();
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }

    const buffer = ctx.createBuffer(1, 1, ctx.sampleRate);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
    await ctx.close();
  }

  get greetingName(): string {
    return this.currentUserName?.trim().split(/\s+/)[0] || 'there';
  }

  onCancelChatbot(history: ChatMessage[]) {
    console.log('Cancel event received! Hiding ChatbotAgent...');
    this.isShowAdminUIControls = false;
    this.isConversationalAgent$.next(false);

    // Voice agent disconnect flushes pending saves; brief delay for DB writes.
    window.setTimeout(() => this.fetchChatHistory(), 800);
  }

  fetchChatHistory(): void {
    this.messagesSubject.next([]);

    this.getChatHistory().subscribe({
      next: (data) => this.applyHistoryMessages(data),
      error: (error) => console.error('Error fetching chat history:', error),
    });
  }

  getChatHistory(): Observable<ChatMessage[]> {
    const headers = new HttpHeaders({
      'X-GFH-AI-CHATBOT-SESSION-ID': this.currentSessionId
    });

    return this.http.get<ChatMessage[]>(`${this.apiUrl}/retrieve_session_conversation_history`, { headers });
  }
} //end class
